var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _line, _rect, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _g, _g2, _g3, _path134, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwardMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 604,
    viewBox: "0 0 331 604",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.868 19.5568H21.8846C16.677 19.5568 12.4614 15.3411 12.4614 10.1336C12.4614 4.93336 16.677 0.710449 21.8846 0.710449H152.868C158.075 0.710449 162.291 4.92607 162.291 10.1336C162.291 15.3411 158.075 19.5568 152.868 19.5568Z",
    stroke: "url(#paint0_linear_2132_129647)",
    strokeWidth: 1.42091,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6391 11.9131H62.677V10.4253H67.2792V9.52089H63.7127V4.43005H65.4485V5.52407H70.8676V4.43005H72.6034V9.52089H69.0369V10.4253H73.6391V11.9131ZM72.9097 15.538H63.7783V12.4237H65.5142V13.9991H72.9097V15.538ZM70.8676 8.03302V7.04111H65.4485V8.03302H70.8676Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8888 10.9431C80.6335 10.7389 80.4001 10.5492 80.1813 10.3669C79.9625 10.1846 79.751 10.0022 79.5395 9.81989C79.328 9.63756 79.1165 9.44793 78.9123 9.2583C78.7008 9.06867 78.482 8.86445 78.2413 8.64565C77.7599 9.09055 77.3004 9.51357 76.8482 9.91471C76.396 10.3159 75.9219 10.7243 75.4187 11.14L74.3757 9.94388C74.8644 9.51357 75.3093 9.11972 75.7031 8.75505C76.1043 8.39038 76.5054 8.01112 76.9211 7.62456C77.067 7.50057 77.1764 7.34012 77.2494 7.15049C77.3223 6.96086 77.3661 6.77123 77.3661 6.5743V4.73635H79.1311V6.5743C79.1311 6.77123 79.1675 6.96086 79.2478 7.15049C79.3207 7.34012 79.4301 7.49328 79.576 7.62456C79.7802 7.8069 79.9625 7.98194 80.1376 8.14969C80.3126 8.31015 80.4877 8.4779 80.6627 8.64565C80.8377 8.8134 81.0274 8.98844 81.2243 9.16348C81.4212 9.33853 81.6473 9.53545 81.8953 9.73967L80.9034 10.9358L80.8888 10.9431ZM84.8418 15.538H75.8855V11.6068H77.6213V13.999H84.8418V15.538ZM84.5793 12.4747H82.8434V7.9163H80.7502V6.37738H82.8434V4.51025H84.5793V12.4747Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9424 7.07032C95.9424 7.34018 95.9205 7.56628 95.8841 7.75591C95.8476 7.94554 95.782 8.10599 95.6944 8.24457C95.6069 8.38314 95.4829 8.49984 95.3371 8.60195C95.1839 8.70406 94.9943 8.80616 94.7682 8.90098C94.0388 9.2146 93.2803 9.52092 92.4926 9.81996C91.7049 10.119 90.9172 10.418 90.1295 10.7171L89.5242 9.38235C90.2973 9.08332 91.0193 8.79158 91.683 8.50713C92.354 8.22269 93.0104 7.94554 93.6523 7.6538C93.8419 7.57357 93.9805 7.46417 94.068 7.32559C94.1555 7.19431 94.192 7.01197 94.192 6.79317V6.30451H90.0566V4.79476H95.9278V7.06303L95.9424 7.07032ZM93.098 15.6183C92.7333 15.6183 92.4051 15.5599 92.0988 15.4578C91.7924 15.3484 91.5299 15.1879 91.3038 14.9837C91.0777 14.7795 90.9099 14.5315 90.7786 14.2325C90.6547 13.9408 90.589 13.6053 90.589 13.2406C90.589 12.8759 90.6547 12.5404 90.7786 12.2487C90.9026 11.9569 91.0777 11.7017 91.3038 11.4975C91.5226 11.2932 91.7924 11.1328 92.0988 11.0234C92.4051 10.914 92.7406 10.8629 93.098 10.8629H97.3573C97.722 10.8629 98.0502 10.914 98.3565 11.0234C98.6629 11.1328 98.9254 11.2932 99.1515 11.4975C99.3776 11.7017 99.5454 11.9496 99.6767 12.2487C99.8079 12.5477 99.8663 12.8759 99.8663 13.2406C99.8663 13.6053 99.8007 13.9408 99.6767 14.2325C99.5527 14.5242 99.3776 14.7795 99.1515 14.9837C98.9254 15.1879 98.6629 15.3484 98.3565 15.4578C98.0502 15.5672 97.7147 15.6183 97.3573 15.6183H93.098ZM97.1677 14.1012C97.4667 14.1012 97.7074 14.0283 97.8752 13.8751C98.0429 13.722 98.1305 13.5104 98.1305 13.2333C98.1305 12.9561 98.0429 12.7446 97.8752 12.5915C97.7074 12.4383 97.474 12.3654 97.1677 12.3654H93.2876C92.9886 12.3654 92.7479 12.4383 92.5801 12.5915C92.4124 12.7446 92.3249 12.9561 92.3249 13.2333C92.3249 13.5104 92.4124 13.722 92.5801 13.8751C92.7479 14.0283 92.9813 14.1012 93.2876 14.1012H97.1677ZM99.5746 10.5785H97.8387V9.69597H96.0591V8.14975H97.8387V7.11408H96.329V5.56787H97.8387V4.5249H99.5746V10.5858V10.5785Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.288 12.606H109.552V9.94391H107.284C106.992 10.2429 106.627 10.4836 106.204 10.6587C105.781 10.8337 105.3 10.9212 104.775 10.9212C104.25 10.9212 103.783 10.8337 103.367 10.666C102.951 10.4909 102.594 10.2648 102.302 9.97309C102.011 9.68135 101.784 9.34585 101.624 8.9593C101.464 8.57274 101.383 8.16431 101.383 7.7267C101.383 7.28909 101.464 6.88066 101.624 6.49411C101.784 6.10755 102.011 5.77205 102.302 5.48032C102.594 5.18858 102.951 4.96248 103.367 4.78744C103.783 4.61239 104.25 4.53217 104.775 4.53217C105.3 4.53217 105.781 4.61969 106.204 4.79473C106.627 4.96977 106.985 5.21046 107.284 5.50949H109.552V4.51758H111.288V12.606ZM111.558 15.538H102.601V11.7308H104.337V13.9991H111.558V15.538ZM104.775 9.41878C105.285 9.41878 105.694 9.25833 105.985 8.94471C106.277 8.63109 106.423 8.22266 106.423 7.7267C106.423 7.23075 106.277 6.82961 105.985 6.50869C105.694 6.19507 105.285 6.03462 104.775 6.03462C104.264 6.03462 103.856 6.19507 103.564 6.50869C103.272 6.82231 103.126 7.23075 103.126 7.7267C103.126 8.22266 103.272 8.63109 103.564 8.94471C103.856 9.25833 104.264 9.41878 104.775 9.41878ZM109.552 8.3977V7.063H108.093C108.144 7.2818 108.166 7.5006 108.166 7.734C108.166 7.96739 108.144 8.19348 108.093 8.40499H109.552V8.3977Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1878 40.292H23.511V34.873C23.511 34.2312 23.6714 33.7279 23.9996 33.3633C24.3279 32.9986 24.78 32.7579 25.3562 32.6412L32.1027 31.2554C32.2048 31.2336 32.2923 31.1825 32.3507 31.1242C32.4163 31.0585 32.4455 30.9783 32.4455 30.8762V27.8494C32.4455 27.7473 32.4163 27.6598 32.3507 27.6014C32.285 27.5358 32.2048 27.5066 32.1027 27.5066H26.7055C26.6034 27.5066 26.5159 27.5358 26.4575 27.6014C26.3992 27.6671 26.3627 27.7473 26.3627 27.8494V30.4313H23.7006V27.3461C23.7006 27.0252 23.759 26.7262 23.883 26.4563C24.0069 26.1865 24.1674 25.9531 24.3643 25.7562C24.5612 25.5592 24.7946 25.3988 25.0645 25.2821C25.3344 25.1654 25.6261 25.1071 25.9324 25.1071H32.8685C33.1748 25.1071 33.4666 25.1654 33.7364 25.2821C34.0063 25.3988 34.2397 25.552 34.4366 25.7562C34.6335 25.9531 34.794 26.1865 34.918 26.4563C35.042 26.7262 35.1003 27.0252 35.1003 27.3461V31.2554C35.1003 31.8973 34.9398 32.4005 34.6116 32.7652C34.2834 33.1299 33.8312 33.3706 33.2551 33.4872L26.5086 34.8584C26.4065 34.8876 26.319 34.9241 26.2606 34.9751C26.195 35.0262 26.1658 35.1064 26.1658 35.2085V37.9071H35.1878V40.2993V40.292Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.257 38.0602C49.257 38.3812 49.1987 38.6802 49.0747 38.95C48.9507 39.2199 48.7902 39.4533 48.5933 39.6502C48.3964 39.8471 48.163 40.0076 47.8931 40.1243C47.6233 40.241 47.3315 40.2993 47.0252 40.2993H39.8922C39.5859 40.2993 39.2941 40.241 39.0243 40.1243C38.7544 40.0076 38.521 39.8544 38.3241 39.6502C38.1272 39.4533 37.9667 39.2199 37.8427 38.95C37.7187 38.6802 37.6604 38.3885 37.6604 38.0602V27.3461C37.6604 27.0252 37.7187 26.7262 37.8427 26.4563C37.9667 26.1865 38.1272 25.9531 38.3241 25.7562C38.521 25.5592 38.7544 25.3988 39.0243 25.2821C39.2941 25.1654 39.5859 25.1071 39.8922 25.1071H47.0252C47.3315 25.1071 47.6233 25.1654 47.8931 25.2821C48.163 25.3988 48.3964 25.552 48.5933 25.7562C48.7902 25.9531 48.9507 26.1865 49.0747 26.4563C49.1987 26.7262 49.257 27.0252 49.257 27.3461V38.0602ZM46.2448 37.9071C46.3469 37.9071 46.4344 37.8779 46.4928 37.8123C46.5511 37.7466 46.5876 37.6664 46.5876 37.5643V27.8494C46.5876 27.7473 46.5584 27.6598 46.4928 27.6014C46.4271 27.5358 46.3469 27.5066 46.2448 27.5066H40.658C40.5559 27.5066 40.4684 27.5358 40.41 27.6014C40.3517 27.6671 40.3152 27.7473 40.3152 27.8494V37.5643C40.3152 37.6664 40.3444 37.7539 40.41 37.8123C40.4757 37.8779 40.5559 37.9071 40.658 37.9071H46.2448Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.399 40.292H51.7222V34.873C51.7222 34.2312 51.8826 33.7279 52.2108 33.3633C52.539 32.9986 52.9912 32.7579 53.5674 32.6412L60.3139 31.2554C60.416 31.2336 60.5035 31.1825 60.5618 31.1242C60.6275 31.0585 60.6567 30.9783 60.6567 30.8762V27.8494C60.6567 27.7473 60.6275 27.6598 60.5618 27.6014C60.4962 27.5358 60.416 27.5066 60.3139 27.5066H54.9167C54.8146 27.5066 54.7271 27.5358 54.6687 27.6014C54.6104 27.6671 54.5739 27.7473 54.5739 27.8494V30.4313H51.9118V27.3461C51.9118 27.0252 51.9701 26.7262 52.0941 26.4563C52.2181 26.1865 52.3786 25.9531 52.5755 25.7562C52.7724 25.5592 53.0058 25.3988 53.2757 25.2821C53.5455 25.1654 53.8373 25.1071 54.1436 25.1071H61.0797C61.386 25.1071 61.6777 25.1654 61.9476 25.2821C62.2175 25.3988 62.4508 25.552 62.6478 25.7562C62.8447 25.9531 63.0052 26.1865 63.1291 26.4563C63.2531 26.7262 63.3115 27.0252 63.3115 27.3461V31.2554C63.3115 31.8973 63.151 32.4005 62.8228 32.7652C62.4946 33.1299 62.0424 33.3706 61.4662 33.4872L54.7198 34.8584C54.6177 34.8876 54.5301 34.9241 54.4718 34.9751C54.4062 35.0262 54.377 35.1064 54.377 35.2085V37.9071H63.399V40.2993V40.292Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6649 38.0602C77.6649 38.3812 77.6066 38.6802 77.4826 38.95C77.3586 39.2199 77.1981 39.4533 77.0012 39.6502C76.8043 39.8471 76.5709 40.0076 76.301 40.1243C76.0312 40.241 75.7394 40.2993 75.4331 40.2993H68.1105C67.8041 40.2993 67.5124 40.241 67.2425 40.1243C66.9727 40.0076 66.7393 39.8544 66.5424 39.6502C66.3454 39.446 66.185 39.2199 66.061 38.95C65.937 38.6802 65.8787 38.3885 65.8787 38.0602V27.3461C65.8787 27.0252 65.937 26.7262 66.061 26.4563C66.185 26.1865 66.3454 25.9531 66.5424 25.7562C66.7393 25.5592 66.9727 25.3988 67.2425 25.2821C67.5124 25.1654 67.8041 25.1071 68.1105 25.1071H75.2435C75.5498 25.1071 75.8415 25.1654 76.1114 25.2821C76.3812 25.3988 76.6146 25.552 76.8116 25.7562C77.0085 25.9531 77.1689 26.1865 77.2929 26.4563C77.4169 26.7262 77.4753 27.0252 77.4753 27.3461V29.2716H74.8132V27.8421C74.8132 27.74 74.784 27.6525 74.7183 27.5941C74.6527 27.5285 74.5725 27.4993 74.4704 27.4993H68.8836C68.7815 27.4993 68.6939 27.5285 68.6356 27.5941C68.5699 27.6598 68.5408 27.74 68.5408 27.8421V31.0804H75.4404C75.7467 31.0804 76.0385 31.1387 76.3083 31.2554C76.5782 31.3721 76.8116 31.5253 77.0085 31.7295C77.2054 31.9264 77.3659 32.1598 77.4899 32.4297C77.6138 32.6996 77.6722 32.9986 77.6722 33.3195V38.0602H77.6649ZM74.6527 37.9071C74.7548 37.9071 74.835 37.8779 74.9007 37.8123C74.9663 37.7466 74.9955 37.6664 74.9955 37.5643V33.8227C74.9955 33.7206 74.9663 33.6331 74.9007 33.5748C74.835 33.5091 74.7548 33.48 74.6527 33.48H68.5262V37.5643C68.5262 37.6664 68.5554 37.7539 68.621 37.8123C68.6866 37.8779 68.7669 37.9071 68.869 37.9071H74.6527Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9453 41.1454H79.9404V38.1186H82.9453V41.1454Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0147 38.0602C97.0147 38.3811 96.9564 38.6802 96.8324 38.95C96.7084 39.2199 96.5479 39.4533 96.351 39.6502C96.1541 39.8471 95.9207 40.0076 95.6508 40.1243C95.381 40.241 95.0892 40.2993 94.7829 40.2993H87.6499C87.3436 40.2993 87.0519 40.241 86.782 40.1243C86.5121 40.0076 86.2787 39.8544 86.0818 39.6502C85.8849 39.4533 85.7244 39.2199 85.6004 38.95C85.4765 38.6802 85.4181 38.3884 85.4181 38.0602V35.7482H88.0802V37.557C88.0802 37.6591 88.1094 37.7466 88.175 37.8049C88.2407 37.8706 88.3209 37.8998 88.423 37.8998H94.0098C94.1119 37.8998 94.1994 37.8706 94.2578 37.8049C94.3234 37.7393 94.3526 37.6591 94.3526 37.557V34.129H87.453C87.1467 34.129 86.8549 34.0707 86.5851 33.954C86.3152 33.8373 86.0818 33.6841 85.8849 33.4799C85.688 33.283 85.5275 33.0496 85.4035 32.7797C85.2795 32.5099 85.2212 32.2181 85.2212 31.8899V27.3388C85.2212 27.0179 85.2795 26.7189 85.4035 26.449C85.5275 26.1792 85.688 25.9458 85.8849 25.7488C86.0818 25.5519 86.3152 25.3915 86.5851 25.2748C86.8549 25.1581 87.1467 25.0997 87.453 25.0997H94.7756C95.082 25.0997 95.3737 25.1581 95.6436 25.2748C95.9134 25.3915 96.1468 25.5446 96.3437 25.7488C96.5406 25.9458 96.7011 26.1792 96.8251 26.449C96.9491 26.7189 97.0074 27.0179 97.0074 27.3388V38.0529L97.0147 38.0602ZM94.3526 31.7368V27.8421C94.3526 27.74 94.3234 27.6524 94.2578 27.5941C94.1922 27.5285 94.1119 27.4993 94.0098 27.4993H88.2261C88.124 27.4993 88.0365 27.5285 87.9781 27.5941C87.9125 27.6597 87.8833 27.74 87.8833 27.8421V31.3867C87.8833 31.4888 87.9125 31.5763 87.9781 31.6347C88.0438 31.7003 88.124 31.7295 88.2261 31.7295H94.3526V31.7368Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.353 41.1454H99.3484V38.1186H102.353V41.1454Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.152 40.292H105.49V27.492H104.06V25.0997H108.144V40.2847L108.152 40.292Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.431 40.292H111.769V27.492H110.34V25.0997H114.424V40.2847L114.431 40.292Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.12 41.1454H117.115V38.1186H120.12V41.1454Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.686 41.7435C123.847 40.3285 123.264 38.8917 122.935 37.4257C122.6 35.9597 122.432 34.5229 122.432 33.108C122.432 31.6931 122.6 30.2781 122.935 28.8194C123.271 27.3607 123.854 25.9312 124.686 24.5309H127.479C127.071 25.2238 126.713 25.9385 126.407 26.6825C126.108 27.4191 125.86 28.1557 125.663 28.8924C125.474 29.6217 125.328 30.3511 125.24 31.0585C125.153 31.7733 125.102 32.4589 125.102 33.108C125.102 33.7571 125.145 34.45 125.24 35.172C125.328 35.8941 125.474 36.6234 125.663 37.3601C125.853 38.0967 126.101 38.8407 126.407 39.5773C126.706 40.3139 127.063 41.036 127.479 41.7435H124.686Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M145.232 33.4362H128.464V31.1242H140.994V26.8429H129.857V24.5309H143.656V31.1242H145.239V33.4362H145.232ZM143.707 41.335H129.988V34.8584H143.707V41.335ZM141.052 39.023V37.134H132.65V39.023H141.052Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M146.216 41.7435C146.624 41.036 146.982 40.3139 147.288 39.5773C147.587 38.8407 147.835 38.0967 148.032 37.3601C148.222 36.6234 148.368 35.8941 148.455 35.172C148.543 34.45 148.586 33.7644 148.586 33.108C148.586 32.4516 148.543 31.766 148.455 31.0585C148.368 30.3438 148.222 29.6217 148.032 28.8924C147.843 28.163 147.595 27.4264 147.288 26.6825C146.989 25.9458 146.632 25.2311 146.216 24.5309H149.009C149.841 25.9312 150.432 27.3607 150.76 28.8194C151.095 30.2781 151.263 31.7077 151.263 33.108C151.263 34.5083 151.095 35.9597 150.76 37.4257C150.424 38.8917 149.841 40.3285 149.009 41.7435H146.216Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M319.038 19.5568H188.055C182.847 19.5568 178.632 15.3411 178.632 10.1336C178.632 4.92607 182.847 0.710449 188.055 0.710449H319.038C324.246 0.710449 328.461 4.92607 328.461 10.1336C328.461 15.3411 324.246 19.5568 319.038 19.5568Z",
    stroke: "url(#paint1_linear_2132_129647)",
    strokeWidth: 1.42091,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M229.292 6.78609C229.292 7.05595 229.277 7.28934 229.241 7.47897C229.204 7.67589 229.146 7.83635 229.058 7.97492C228.971 8.1135 228.854 8.23749 228.701 8.3396C228.548 8.44171 228.358 8.53652 228.125 8.62404C227.359 8.91578 226.593 9.20023 225.827 9.47008C225.062 9.73994 224.281 10.0025 223.494 10.2505L222.888 8.96683C223.574 8.72615 224.267 8.47088 224.96 8.21561C225.652 7.96034 226.338 7.69777 227.016 7.42791C227.381 7.28204 227.556 6.9976 227.556 6.57458V6.27555H223.421V4.81685H229.292V6.79338V6.78609ZM232.982 15.6695H224.237V12.4093H230.991V11.855H224.223V10.4182H232.727V13.6784H225.973V14.2327H232.975V15.6695H232.982ZM232.727 10.0463H230.991V4.51782H232.727V6.45788H234.135V8.05515H232.727V10.0463Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M241.902 13.8751H235.061V8.53628H239.342V6.45764H235.046V4.91872H241.078V10.046H236.797V12.3362H241.902V13.8751ZM244.346 15.6401H242.61V4.51758H244.346V8.58733H245.855V10.2502H244.346V15.6401Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M260.662 11.6943H249.699V10.1846H253.616V8.95197H255.381V10.1846H260.662V11.6943ZM259.67 9.64485H257.934V8.47061H250.611V6.98274H257.934V6.06376H250.611V4.55402H259.67V9.64485ZM259.932 15.538H250.801V12.2632H252.537V13.999H259.932V15.538Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M267.984 13.9772C267.561 13.4593 267.174 12.9707 266.824 12.5112C266.474 12.0517 266.131 11.6141 265.818 11.1838C265.73 11.0744 265.657 10.965 265.584 10.8629C265.511 10.7608 265.446 10.6441 265.387 10.5274C265.263 10.7608 265.117 10.9796 264.957 11.1838C264.629 11.6141 264.25 12.0882 263.827 12.606C263.396 13.1238 262.973 13.6417 262.543 14.1522L261.361 12.905C261.857 12.3143 262.324 11.7308 262.769 11.1473C263.214 10.5638 263.622 10.0022 264.002 9.46252C264.162 9.23642 264.286 8.98115 264.366 8.704C264.454 8.42684 264.49 8.11322 264.49 7.77043V4.83117H266.255V7.77043C266.255 8.11322 266.299 8.42684 266.379 8.704C266.459 8.98115 266.583 9.23642 266.729 9.46252C267.094 10.0095 267.459 10.5565 267.838 11.1035C268.217 11.6506 268.648 12.2122 269.122 12.7883L267.977 13.9699L267.984 13.9772ZM271.689 15.6401H269.953V9.37499H267.663V7.73397H269.953V4.51025H271.689V15.6328V15.6401Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M284.102 14.8962H273.14V13.3573H284.102V14.8962ZM283.293 11.9205H274.154V4.80206H283.074V6.34098H275.89V7.60275H282.943V9.1125H275.89V10.3889H283.285V11.9278L283.293 11.9205Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M201.351 40.292H189.674V34.873C189.674 34.2312 189.834 33.7279 190.162 33.3633C190.491 32.9986 190.943 32.7579 191.519 32.6412L198.266 31.2554C198.368 31.2336 198.455 31.1825 198.514 31.1242C198.579 31.0585 198.608 30.9783 198.608 30.8762V27.8494C198.608 27.7473 198.579 27.6598 198.514 27.6014C198.448 27.5358 198.368 27.5066 198.266 27.5066H192.868C192.766 27.5066 192.679 27.5358 192.62 27.6014C192.555 27.6671 192.526 27.7473 192.526 27.8494V30.4313H189.863V27.3461C189.863 27.0252 189.922 26.7262 190.046 26.4563C190.17 26.1865 190.33 25.9531 190.527 25.7562C190.724 25.5592 190.957 25.3988 191.227 25.2821C191.497 25.1654 191.789 25.1071 192.095 25.1071H199.031C199.338 25.1071 199.629 25.1654 199.899 25.2821C200.169 25.3988 200.403 25.552 200.599 25.7562C200.796 25.9531 200.957 26.1865 201.081 26.4563C201.205 26.7262 201.263 27.0252 201.263 27.3461V31.2554C201.263 31.8973 201.103 32.4005 200.774 32.7652C200.446 33.1299 199.994 33.3706 199.418 33.4872L192.671 34.8584C192.569 34.8876 192.482 34.9241 192.423 34.9751C192.358 35.0262 192.329 35.1064 192.329 35.2085V37.9071H201.351V40.2993V40.292Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M215.42 38.0602C215.42 38.3812 215.361 38.6802 215.238 38.95C215.114 39.2199 214.953 39.4533 214.756 39.6502C214.559 39.8471 214.326 40.0076 214.056 40.1243C213.786 40.241 213.494 40.2993 213.188 40.2993H206.055C205.749 40.2993 205.457 40.241 205.187 40.1243C204.917 40.0076 204.684 39.8544 204.487 39.6502C204.29 39.446 204.13 39.2199 204.006 38.95C203.882 38.6802 203.823 38.3885 203.823 38.0602V27.3461C203.823 27.0252 203.882 26.7262 204.006 26.4563C204.13 26.1865 204.29 25.9531 204.487 25.7562C204.684 25.5592 204.917 25.3988 205.187 25.2821C205.457 25.1654 205.749 25.1071 206.055 25.1071H213.188C213.494 25.1071 213.786 25.1654 214.056 25.2821C214.326 25.3988 214.559 25.552 214.756 25.7562C214.953 25.9531 215.114 26.1865 215.238 26.4563C215.361 26.7262 215.42 27.0252 215.42 27.3461V38.0602ZM212.415 37.9071C212.517 37.9071 212.605 37.8779 212.663 37.8123C212.729 37.7466 212.758 37.6664 212.758 37.5643V27.8494C212.758 27.7473 212.729 27.6598 212.663 27.6014C212.597 27.5358 212.517 27.5066 212.415 27.5066H206.828C206.726 27.5066 206.639 27.5358 206.58 27.6014C206.515 27.6671 206.485 27.7473 206.485 27.8494V37.5643C206.485 37.6664 206.515 37.7539 206.58 37.8123C206.646 37.8779 206.726 37.9071 206.828 37.9071H212.415Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M229.569 40.292H217.892V34.873C217.892 34.2312 218.053 33.7279 218.381 33.3633C218.709 32.9986 219.161 32.7579 219.738 32.6412L226.484 31.2554C226.586 31.2336 226.674 31.1825 226.732 31.1242C226.798 31.0585 226.827 30.9783 226.827 30.8762V27.8494C226.827 27.7473 226.798 27.6598 226.732 27.6014C226.666 27.5358 226.586 27.5066 226.484 27.5066H221.087C220.985 27.5066 220.897 27.5358 220.839 27.6014C220.781 27.6671 220.744 27.7473 220.744 27.8494V30.4313H218.082V27.3461C218.082 27.0252 218.14 26.7262 218.264 26.4563C218.388 26.1865 218.549 25.9531 218.746 25.7562C218.943 25.5592 219.176 25.3988 219.446 25.2821C219.716 25.1654 220.007 25.1071 220.314 25.1071H227.25C227.556 25.1071 227.848 25.1654 228.118 25.2821C228.388 25.3988 228.621 25.552 228.818 25.7562C229.015 25.9531 229.175 26.1865 229.299 26.4563C229.423 26.7262 229.482 27.0252 229.482 27.3461V31.2554C229.482 31.8973 229.321 32.4005 228.993 32.7652C228.665 33.1299 228.213 33.3706 227.636 33.4872L220.89 34.8584C220.788 34.8876 220.7 34.9241 220.642 34.9751C220.576 35.0262 220.547 35.1064 220.547 35.2085V37.9071H229.569V40.2993V40.292Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M243.828 38.0602C243.828 38.3812 243.77 38.6802 243.646 38.95C243.522 39.2199 243.361 39.4533 243.164 39.6502C242.967 39.8471 242.734 40.0076 242.464 40.1243C242.194 40.241 241.903 40.2993 241.596 40.2993H234.274C233.967 40.2993 233.676 40.241 233.406 40.1243C233.136 40.0076 232.902 39.8544 232.705 39.6502C232.509 39.4533 232.348 39.2199 232.224 38.95C232.1 38.6802 232.042 38.3885 232.042 38.0602V27.3461C232.042 27.0252 232.1 26.7262 232.224 26.4563C232.348 26.1865 232.509 25.9531 232.705 25.7562C232.902 25.5592 233.136 25.3988 233.406 25.2821C233.676 25.1654 233.967 25.1071 234.274 25.1071H241.407C241.713 25.1071 242.005 25.1654 242.274 25.2821C242.544 25.3988 242.778 25.552 242.975 25.7562C243.172 25.9531 243.332 26.1865 243.456 26.4563C243.58 26.7262 243.638 27.0252 243.638 27.3461V29.2716H240.976V27.8421C240.976 27.74 240.947 27.6525 240.881 27.5941C240.816 27.5285 240.736 27.4993 240.633 27.4993H235.047C234.945 27.4993 234.857 27.5285 234.799 27.5941C234.733 27.6598 234.704 27.74 234.704 27.8421V31.0804H241.603C241.91 31.0804 242.202 31.1387 242.471 31.2554C242.741 31.3721 242.975 31.5253 243.172 31.7295C243.369 31.9264 243.529 32.1598 243.653 32.4297C243.777 32.6996 243.835 32.9986 243.835 33.3195V38.0602H243.828ZM240.823 37.9071C240.925 37.9071 241.005 37.8779 241.071 37.8123C241.137 37.7466 241.166 37.6664 241.166 37.5643V33.8227C241.166 33.7206 241.137 33.6331 241.071 33.5748C241.005 33.5164 240.925 33.48 240.823 33.48H234.697V37.5643C234.697 37.6664 234.726 37.7539 234.791 37.8123C234.857 37.8779 234.937 37.9071 235.039 37.9071H240.823Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M249.109 41.1454H246.104V38.1186H249.109V41.1454Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M263.178 38.0602C263.178 38.3811 263.119 38.6802 262.995 38.95C262.871 39.2199 262.711 39.4533 262.514 39.6502C262.317 39.8471 262.084 40.0076 261.814 40.1243C261.544 40.241 261.252 40.2993 260.946 40.2993H253.813C253.506 40.2993 253.215 40.241 252.945 40.1243C252.675 40.0076 252.442 39.8544 252.245 39.6502C252.048 39.446 251.887 39.2199 251.763 38.95C251.639 38.6802 251.581 38.3884 251.581 38.0602V35.7482H254.243V37.557C254.243 37.6591 254.272 37.7466 254.338 37.8049C254.404 37.8706 254.484 37.8998 254.586 37.8998H260.173C260.275 37.8998 260.362 37.8706 260.421 37.8049C260.486 37.7393 260.515 37.6591 260.515 37.557V34.129H253.616C253.31 34.129 253.018 34.0707 252.748 33.954C252.478 33.8373 252.245 33.6841 252.048 33.4799C251.851 33.283 251.69 33.0496 251.566 32.7797C251.442 32.5099 251.384 32.2181 251.384 31.8899V27.3388C251.384 27.0179 251.442 26.7189 251.566 26.449C251.69 26.1792 251.851 25.9458 252.048 25.7488C252.245 25.5519 252.478 25.3915 252.748 25.2748C253.018 25.1581 253.31 25.0997 253.616 25.0997H260.938C261.245 25.0997 261.537 25.1581 261.806 25.2748C262.076 25.3915 262.31 25.5446 262.507 25.7488C262.703 25.9458 262.864 26.1792 262.988 26.449C263.112 26.7189 263.17 27.0179 263.17 27.3388V38.0529L263.178 38.0602ZM260.523 31.7368V27.8421C260.523 27.74 260.494 27.6524 260.428 27.5941C260.362 27.5285 260.282 27.4993 260.18 27.4993H254.396C254.294 27.4993 254.214 27.5285 254.148 27.5941C254.083 27.6597 254.053 27.74 254.053 27.8421V31.3867C254.053 31.4888 254.083 31.5763 254.148 31.6347C254.214 31.7003 254.294 31.7295 254.396 31.7295H260.523V31.7368Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M268.516 41.1454H265.511V38.1186H268.516V41.1454Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M274.322 40.292H271.66V27.492H270.23V25.0997H274.315V40.2847L274.322 40.292Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M288.814 40.292H277.137V34.873C277.137 34.2312 277.298 33.7279 277.626 33.3633C277.954 32.9986 278.406 32.7579 278.982 32.6412L285.729 31.2554C285.831 31.2336 285.911 31.1825 285.977 31.1242C286.043 31.0585 286.072 30.9783 286.072 30.8762V27.8494C286.072 27.7473 286.043 27.6598 285.977 27.6014C285.911 27.5358 285.831 27.5066 285.729 27.5066H280.332C280.23 27.5066 280.149 27.5358 280.084 27.6014C280.018 27.6671 279.989 27.7473 279.989 27.8494V30.4313H277.327V27.3461C277.327 27.0252 277.385 26.7262 277.509 26.4563C277.633 26.1865 277.794 25.9531 277.991 25.7562C278.187 25.5592 278.421 25.3988 278.691 25.2821C278.961 25.1654 279.252 25.1071 279.559 25.1071H286.495C286.801 25.1071 287.093 25.1654 287.363 25.2821C287.632 25.3988 287.866 25.552 288.063 25.7562C288.26 25.9531 288.42 26.1865 288.544 26.4563C288.668 26.7262 288.727 27.0252 288.727 27.3461V31.2554C288.727 31.8973 288.566 32.4005 288.238 32.7652C287.91 33.1299 287.457 33.3706 286.881 33.4872L280.135 34.8584C280.033 34.8876 279.952 34.9241 279.887 34.9751C279.821 35.0262 279.792 35.1064 279.792 35.2085V37.9071H288.814V40.2993V40.292Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M294.153 41.1454H291.148V38.1186H294.153V41.1454Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M298.718 41.7435C297.88 40.3285 297.296 38.8917 296.961 37.4257C296.625 35.9597 296.458 34.5229 296.458 33.108C296.458 31.6931 296.625 30.2781 296.961 28.8194C297.296 27.3607 297.88 25.9312 298.718 24.5309H301.512C301.103 25.2238 300.746 25.9385 300.44 26.6825C300.141 27.4191 299.893 28.1557 299.696 28.8924C299.499 29.6217 299.36 30.3511 299.273 31.0585C299.185 31.7733 299.134 32.4589 299.134 33.108C299.134 33.7571 299.178 34.45 299.273 35.172C299.36 35.8941 299.506 36.6234 299.696 37.3601C299.885 38.0967 300.133 38.8407 300.44 39.5773C300.739 40.3139 301.096 41.036 301.512 41.7435H298.718Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M319.264 40.3504H302.497V38.0019H309.63V35.5367H304.057V24.9174H317.703V27.2659H306.72V29.0601H317.514V31.3721H306.72V33.1809H318.032V35.5294H312.328V37.9946H319.264V40.3431V40.3504Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M320.249 41.7435C320.657 41.036 321.015 40.3139 321.321 39.5773C321.62 38.8407 321.868 38.0967 322.065 37.3601C322.255 36.6234 322.401 35.8941 322.488 35.172C322.576 34.45 322.619 33.7644 322.619 33.108C322.619 32.4516 322.576 31.766 322.488 31.0585C322.401 30.3438 322.255 29.6217 322.065 28.8924C321.875 28.163 321.627 27.4264 321.321 26.6825C321.022 25.9458 320.665 25.2311 320.249 24.5309H323.042C323.874 25.9312 324.465 27.3607 324.793 28.8194C325.128 30.2781 325.296 31.7077 325.296 33.108C325.296 34.5083 325.128 35.9597 324.793 37.4257C324.457 38.8917 323.874 40.3285 323.042 41.7435H320.249Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.4614,
    y1: 57.2435,
    x2: 330.461,
    y2: 57.2435,
    stroke: "white",
    strokeOpacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.4614,
    y: 73.7435,
    width: 320,
    height: 52,
    rx: 8,
    fill: "url(#paint2_linear_2132_129647)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5814 100.043H81.8214V97.6435H83.6214V92.7435H82.0214V90.3435H93.2814V92.7435H91.5414V97.6435H93.5814V100.043ZM97.8414 107.283H83.9414V101.443H86.7014V104.843H97.8414V107.283ZM97.4214 102.823H94.6614V89.7835H97.4214V93.9635H99.6614V96.5035H97.4214V102.823ZM88.7814 97.6435V92.7435H86.3814V97.6435H88.7814ZM117.51 106.263H100.11V103.823H103.69V97.6835H106.45V103.823H108.57V97.6835H111.33V103.823H117.51V106.263ZM115.79 101.223H113.03V92.8635H101.63V90.4235H115.79V101.223ZM134.418 99.7435H131.658V98.2835H127.778C127.312 98.6701 126.765 98.9768 126.138 99.2035C125.525 99.4301 124.838 99.5435 124.078 99.5435C123.252 99.5435 122.505 99.4168 121.838 99.1635C121.185 98.8968 120.625 98.5435 120.158 98.1035C119.692 97.6501 119.332 97.1235 119.078 96.5235C118.825 95.9235 118.698 95.2901 118.698 94.6235C118.698 93.9568 118.825 93.3235 119.078 92.7235C119.332 92.1235 119.692 91.6035 120.158 91.1635C120.625 90.7101 121.185 90.3568 121.838 90.1035C122.505 89.8368 123.252 89.7035 124.078 89.7035C124.932 89.7035 125.698 89.8435 126.378 90.1235C127.058 90.4035 127.632 90.7835 128.098 91.2635H131.658V89.7835H134.418V99.7435ZM134.418 107.483H131.658V102.863H120.418V100.423H134.418V107.483ZM124.078 97.1435C124.892 97.1435 125.532 96.9101 125.998 96.4435C126.465 95.9768 126.698 95.3701 126.698 94.6235C126.698 93.8768 126.465 93.2701 125.998 92.8035C125.532 92.3368 124.892 92.1035 124.078 92.1035C123.265 92.1035 122.625 92.3368 122.158 92.8035C121.692 93.2701 121.458 93.8768 121.458 94.6235C121.458 95.3701 121.692 95.9768 122.158 96.4435C122.625 96.9101 123.265 97.1435 124.078 97.1435ZM131.658 95.8235V93.7235H129.378C129.405 93.8701 129.425 94.0235 129.438 94.1835C129.452 94.3301 129.458 94.4768 129.458 94.6235C129.458 95.0235 129.405 95.4235 129.298 95.8235H131.658ZM146.797 107.403C146.223 107.403 145.69 107.323 145.197 107.163C144.717 107.003 144.297 106.77 143.937 106.463C143.59 106.17 143.317 105.803 143.117 105.363C142.917 104.923 142.817 104.43 142.817 103.883C142.817 103.337 142.917 102.843 143.117 102.403C143.317 101.963 143.59 101.597 143.937 101.303C144.297 100.997 144.717 100.763 145.197 100.603C145.69 100.443 146.223 100.363 146.797 100.363H153.237C153.81 100.363 154.337 100.443 154.817 100.603C155.31 100.763 155.73 100.997 156.077 101.303C156.437 101.597 156.717 101.963 156.917 102.403C157.117 102.843 157.217 103.337 157.217 103.883C157.217 104.43 157.117 104.923 156.917 105.363C156.717 105.803 156.437 106.17 156.077 106.463C155.73 106.77 155.31 107.003 154.817 107.163C154.337 107.323 153.81 107.403 153.237 107.403H146.797ZM153.197 99.4035H141.077V97.0835H144.517V94.3835H147.317V97.0835H153.197V99.4035ZM152.297 96.3635H149.537V92.3635H141.817V90.0435H152.297V96.3635ZM156.757 99.9235H153.997V89.7835H156.757V93.5235H158.857V96.0635H156.757V99.9235ZM152.937 105.043C153.417 105.043 153.79 104.943 154.057 104.743C154.323 104.53 154.457 104.243 154.457 103.883C154.457 103.523 154.323 103.243 154.057 103.043C153.79 102.83 153.417 102.723 152.937 102.723H147.097C146.617 102.723 146.243 102.83 145.977 103.043C145.71 103.243 145.577 103.523 145.577 103.883C145.577 104.243 145.71 104.53 145.977 104.743C146.243 104.943 146.617 105.043 147.097 105.043H152.937ZM164.805 107.403C164.232 107.403 163.699 107.317 163.205 107.143C162.725 106.97 162.305 106.717 161.945 106.383C161.599 106.063 161.325 105.67 161.125 105.203C160.925 104.737 160.825 104.21 160.825 103.623C160.825 103.037 160.925 102.51 161.125 102.043C161.325 101.577 161.599 101.183 161.945 100.863C162.305 100.53 162.725 100.277 163.205 100.103C163.699 99.9301 164.232 99.8435 164.805 99.8435H171.245C171.819 99.8435 172.345 99.9301 172.825 100.103C173.319 100.277 173.739 100.53 174.085 100.863C174.445 101.183 174.725 101.577 174.925 102.043C175.125 102.51 175.225 103.037 175.225 103.623C175.225 104.21 175.125 104.737 174.925 105.203C174.725 105.67 174.445 106.063 174.085 106.383C173.739 106.717 173.319 106.97 172.825 107.143C172.345 107.317 171.819 107.403 171.245 107.403H164.805ZM169.165 99.0835C168.445 98.5635 167.752 98.0568 167.085 97.5635C166.419 97.0568 165.745 96.5501 165.065 96.0435C164.345 96.6035 163.612 97.1635 162.865 97.7235C162.132 98.2835 161.385 98.8435 160.625 99.4035L158.965 97.5835C159.645 97.0635 160.325 96.5368 161.005 96.0035C161.699 95.4701 162.379 94.9301 163.045 94.3835C163.459 94.0368 163.665 93.5501 163.665 92.9235V92.6035H159.745V90.2435H170.265V92.6035H166.465V92.9235C166.465 93.5501 166.672 94.0368 167.085 94.3835C167.659 94.8768 168.259 95.3701 168.885 95.8635C169.512 96.3435 170.132 96.8101 170.745 97.2635L169.165 99.0835ZM174.765 99.4035H172.005V89.7835H174.765V93.0835H177.005V95.6235H174.765V99.4035ZM170.945 105.003C171.425 105.003 171.799 104.883 172.065 104.643C172.332 104.403 172.465 104.063 172.465 103.623C172.465 103.183 172.332 102.843 172.065 102.603C171.799 102.363 171.425 102.243 170.945 102.243H165.105C164.625 102.243 164.252 102.363 163.985 102.603C163.719 102.843 163.585 103.183 163.585 103.623C163.585 104.063 163.719 104.403 163.985 104.643C164.252 104.883 164.625 105.003 165.105 105.003H170.945ZM195.224 106.923H192.544V98.4235H190.684V104.443H182.864V90.5435H190.684V95.7835H192.544V89.9835H195.224V106.923ZM199.204 107.423H196.484V89.7835H199.204V107.423ZM187.964 102.003V92.9835H185.584V102.003H187.964ZM216.512 102.423H213.752V89.7835H216.512V102.423ZM216.932 107.283H202.712V101.043H205.472V104.843H216.932V107.283ZM211.352 96.7835C211.099 97.3968 210.732 97.9368 210.252 98.4035C209.785 98.8568 209.212 99.2168 208.532 99.4835C207.865 99.7501 207.112 99.8835 206.272 99.8835C205.432 99.8835 204.672 99.7501 203.992 99.4835C203.325 99.2168 202.752 98.8568 202.272 98.4035C201.805 97.9368 201.439 97.3968 201.172 96.7835C200.919 96.1701 200.792 95.5235 200.792 94.8435C200.792 94.1635 200.919 93.5168 201.172 92.9035C201.439 92.2901 201.805 91.7568 202.272 91.3035C202.752 90.8368 203.325 90.4701 203.992 90.2035C204.672 89.9368 205.432 89.8035 206.272 89.8035C207.112 89.8035 207.865 89.9368 208.532 90.2035C209.212 90.4701 209.785 90.8368 210.252 91.3035C210.732 91.7568 211.099 92.2901 211.352 92.9035C211.619 93.5168 211.752 94.1635 211.752 94.8435C211.752 95.5235 211.619 96.1701 211.352 96.7835ZM206.272 97.4835C207.112 97.4835 207.772 97.2368 208.252 96.7435C208.745 96.2501 208.992 95.6168 208.992 94.8435C208.992 94.0701 208.745 93.4368 208.252 92.9435C207.772 92.4501 207.112 92.2035 206.272 92.2035C205.432 92.2035 204.765 92.4501 204.272 92.9435C203.792 93.4368 203.552 94.0701 203.552 94.8435C203.552 95.6168 203.792 96.2501 204.272 96.7435C204.765 97.2368 205.432 97.4835 206.272 97.4835ZM238.93 98.1035H224.97V90.0835H238.93V98.1035ZM240.65 102.263H233.35V107.443H230.55V102.263H223.25V99.8235H240.65V102.263ZM236.17 95.6635V92.5235H227.73V95.6635H236.17ZM258.399 107.423H255.679V98.6235H254.019V106.923H251.339V89.9835H254.019V95.9835H255.679V89.7835H258.399V107.423ZM250.219 104.443H242.159V90.5435H249.719V92.9835H244.879V102.003H250.219V104.443Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M150.533 182.444H124.85V172.146C124.85 170.478 125.32 169.126 126.259 168.098C127.198 167.071 128.479 166.417 130.097 166.132L143.211 163.816V158.417H132.952V162.661H125.237V157.11C125.237 155.441 125.757 154.083 126.798 153.043C127.838 152.002 129.196 151.482 130.865 151.482H145.286C146.955 151.482 148.312 152.002 149.353 153.043C150.393 154.083 150.914 155.441 150.914 157.11V164.165C150.914 165.833 150.451 167.185 149.524 168.213C148.598 169.24 147.31 169.894 145.667 170.179L132.552 172.495V175.503H150.527V182.444H150.533Z",
    fill: "#BBA4CE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M159.282 187.881H153.496L155.038 175.579H162.715L159.282 187.881Z",
    fill: "#BBA4CE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M176.679 182.444H168.583V158.417H164.885V151.476H176.685V182.444H176.679Z",
    fill: "#BBA4CE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M207.451 176.81C207.451 178.478 206.93 179.836 205.89 180.876C204.849 181.917 203.492 182.437 201.823 182.437H187.015C185.346 182.437 183.988 181.917 182.948 180.876C181.907 179.836 181.387 178.478 181.387 176.81V157.103C181.387 155.435 181.907 154.077 182.948 153.036C183.988 151.996 185.346 151.476 187.015 151.476H201.823C203.492 151.476 204.849 151.996 205.89 153.036C206.93 154.077 207.451 155.435 207.451 157.103V176.81ZM199.736 175.496V158.41H189.089V175.496H199.736Z",
    fill: "#BBA4CE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M237.53 176.81C237.53 178.478 237.01 179.836 235.97 180.876C234.929 181.917 233.571 182.437 231.903 182.437H217.094C215.426 182.437 214.068 181.917 213.028 180.876C211.987 179.836 211.467 178.478 211.467 176.81V157.103C211.467 155.435 211.987 154.077 213.028 153.036C214.068 151.996 215.426 151.476 217.094 151.476H231.903C233.571 151.476 234.929 151.996 235.97 153.036C237.01 154.077 237.53 155.435 237.53 157.103V176.81ZM229.822 175.496V158.41H219.175V175.496H229.822Z",
    fill: "#BBA4CE"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M261.748 169.291H241.426V150.587H261.748V169.291ZM272.895 184.252H243.545V171.563H251.102V177.926H272.889V184.252H272.895ZM254.191 162.928V156.951H248.982V162.928H254.191ZM272.318 174.614H264.761V150.2H272.318V156.989H276.099V163.467H272.318V174.614Z",
    fill: "#BBA4CE"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M310.303 176.657H302.747V175.464H294.226V170.643H302.747V166.709L300.126 169.329H292.335V174.38H284.582V169.329H277.292V164.12H302.747V150.2H310.303V176.657ZM286.124 162.813C283.58 162.813 281.581 162.242 280.128 161.1C278.675 159.958 277.952 158.353 277.952 156.297C277.952 154.242 278.675 152.605 280.128 151.457C281.581 150.314 283.58 149.743 286.124 149.743H292.836C295.38 149.743 297.379 150.314 298.832 151.457C300.285 152.599 301.008 154.216 301.008 156.297C301.008 158.378 300.278 159.958 298.832 161.1C297.379 162.242 295.38 162.813 292.836 162.813H286.124ZM310.455 184.252H280.223V175.268H287.78V178.853H310.455V184.252ZM291.485 157.604C292.075 157.604 292.551 157.497 292.912 157.275C293.274 157.059 293.452 156.716 293.452 156.253C293.452 155.79 293.274 155.454 292.912 155.251C292.551 155.048 292.075 154.94 291.485 154.94H287.475C286.885 154.94 286.409 155.041 286.048 155.251C285.686 155.454 285.508 155.79 285.508 156.253C285.508 156.716 285.686 157.059 286.048 157.275C286.409 157.49 286.885 157.604 287.475 157.604H291.485Z",
    fill: "#BBA4CE"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4997 172.774H30.4614V168.758H40.175V166.779H46.7861V168.758H56.4997V172.774ZM55.1737 167.959C53.1434 167.565 51.1765 167.178 49.2668 166.791C47.3571 166.411 45.4283 165.96 43.4805 165.446C41.5137 165.96 39.5723 166.404 37.6689 166.791C35.7592 167.172 33.7923 167.565 31.7621 167.959L30.5502 164.12C32.0666 163.803 33.5512 163.486 35.0105 163.162C36.4634 162.839 37.9354 162.458 39.4073 162.027C39.7436 161.931 39.9783 161.811 40.1179 161.671H31.7367V157.687H40.0925V155.974H46.8813V157.687H55.2625V161.671H46.8178C46.9193 161.811 47.1604 161.925 47.5538 162.027C49.0321 162.458 50.4913 162.839 51.9379 163.162C53.3845 163.486 54.8755 163.809 56.4109 164.12L55.1737 167.959ZM49.9774 173.745C50.9989 173.745 51.8808 173.866 52.6168 174.113C53.3527 174.361 53.9618 174.697 54.444 175.128C54.9262 175.56 55.2879 176.067 55.5226 176.651C55.7574 177.235 55.8779 177.844 55.8779 178.497C55.8779 179.151 55.7574 179.753 55.5099 180.324C55.2625 180.895 54.8945 181.397 54.3996 181.828C53.9047 182.26 53.2893 182.602 52.5406 182.85C51.792 183.097 50.9037 183.218 49.8823 183.218H36.9266C35.9051 183.218 35.0295 183.097 34.2999 182.85C33.5703 182.602 32.9739 182.266 32.498 181.828C32.0285 181.397 31.6796 180.895 31.4512 180.324C31.2228 179.753 31.1086 179.144 31.1086 178.497C31.1086 177.85 31.2291 177.235 31.4639 176.651C31.6986 176.074 32.0603 175.566 32.5425 175.128C33.0246 174.697 33.6337 174.354 34.3697 174.113C35.1057 173.866 35.9876 173.745 37.0091 173.745H49.9647H49.9774ZM48.6768 179.151C49.1272 179.151 49.4889 179.1 49.7554 179.005C50.0218 178.903 50.1551 178.738 50.1551 178.504C50.1551 178.053 49.6602 177.825 48.6768 177.825H38.3478C37.3644 177.825 36.8695 178.053 36.8695 178.504C36.8695 178.738 37.0027 178.91 37.2692 179.005C37.5357 179.1 37.891 179.151 38.3478 179.151H48.6768Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8244 170.617C71.8029 169.926 70.7941 169.221 69.798 168.492C68.8019 167.762 67.8439 166.944 66.9175 166.043C65.9722 166.912 64.9951 167.718 63.98 168.46C62.9649 169.209 61.8799 169.964 60.7189 170.731L57.4133 166.804C58.5173 165.979 59.5451 165.18 60.4968 164.412C61.4485 163.645 62.3431 162.82 63.1679 161.931C63.4407 161.659 63.6183 161.392 63.7008 161.132C63.777 160.878 63.8214 160.542 63.8214 160.13V156.678H70.0201V160.104C70.0201 160.479 70.0581 160.802 70.1406 161.081C70.2167 161.354 70.388 161.633 70.6418 161.906C71.4476 162.775 72.3041 163.594 73.2114 164.368C74.1187 165.148 75.083 165.948 76.1045 166.772L72.8307 170.611L72.8244 170.617ZM77.6653 171.417C78.6868 171.417 79.575 171.575 80.3237 171.886C81.0724 172.203 81.6878 172.628 82.17 173.168C82.6522 173.707 83.0138 174.342 83.2486 175.058C83.4833 175.775 83.6038 176.53 83.6038 177.317C83.6038 178.104 83.4833 178.859 83.2359 179.576C82.9884 180.293 82.6204 180.921 82.1256 181.467C81.6307 182.006 81.0089 182.437 80.2539 182.748C79.4989 183.065 78.6043 183.218 77.5828 183.218H65.4202C64.3987 183.218 63.5168 183.059 62.7809 182.748C62.0449 182.431 61.4358 182.006 60.9663 181.467C60.4968 180.927 60.1479 180.293 59.9194 179.576C59.691 178.859 59.5768 178.104 59.5768 177.317C59.5768 176.53 59.6974 175.775 59.9321 175.058C60.1669 174.342 60.5285 173.713 61.0107 173.168C61.4929 172.628 62.1083 172.197 62.857 171.886C63.6057 171.569 64.4876 171.417 65.5154 171.417H77.678H77.6653ZM76.3393 178.408C76.7897 178.408 77.1514 178.307 77.4179 178.11C77.6843 177.914 77.8176 177.647 77.8176 177.311C77.8176 176.975 77.6907 176.708 77.4369 176.499C77.1831 176.289 76.8151 176.188 76.3456 176.188H66.8414C66.3719 176.188 66.0039 176.289 65.7501 176.499C65.4964 176.708 65.3695 176.975 65.3695 177.311C65.3695 177.647 65.5027 177.914 65.7692 178.11C66.0356 178.307 66.3909 178.408 66.8478 178.408H76.352H76.3393ZM82.5951 170.731H76.8088V156.678H82.5951V160.751H85.4882V165.713H82.5951V170.731Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M112.586 170.649H86.5479V166.163H105.442V161.265H87.9056V156.78H111.228V166.17H112.586V170.655V170.649ZM111.228 182.748H105.442V180.033L102.727 182.748H87.9056V172.121H111.228V182.748ZM105.442 178.262V176.606H93.6919V178.262H105.442Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M150.533 182.444H124.85V172.146C124.85 170.478 125.32 169.126 126.259 168.098C127.198 167.071 128.479 166.417 130.097 166.132L143.211 163.816V158.417H132.952V162.661H125.237V157.11C125.237 155.441 125.757 154.083 126.798 153.043C127.838 152.002 129.196 151.482 130.865 151.482H145.286C146.955 151.482 148.312 152.002 149.353 153.043C150.393 154.083 150.914 155.441 150.914 157.11V164.165C150.914 165.833 150.451 167.185 149.524 168.213C148.598 169.24 147.31 169.894 145.667 170.179L132.552 172.495V175.503H150.52V182.444H150.533ZM159.289 187.881H153.502L155.044 175.579H162.721L159.289 187.881ZM176.679 182.444H168.583V158.417H164.878V151.476H176.679V182.444ZM207.45 176.81C207.45 178.478 206.93 179.836 205.89 180.876C204.849 181.917 203.491 182.437 201.823 182.437H187.015C185.346 182.437 183.988 181.917 182.948 180.876C181.907 179.836 181.387 178.478 181.387 176.81V157.103C181.387 155.435 181.907 154.077 182.948 153.036C183.988 151.996 185.346 151.476 187.015 151.476H201.823C203.491 151.476 204.849 151.996 205.89 153.036C206.93 154.077 207.45 155.435 207.45 157.103V176.81ZM199.742 175.496V158.41H189.096V175.496H199.742ZM237.53 176.81C237.53 178.478 237.01 179.836 235.969 180.876C234.929 181.917 233.571 182.437 231.903 182.437H217.094C215.426 182.437 214.068 181.917 213.027 180.876C211.987 179.836 211.467 178.478 211.467 176.81V157.103C211.467 155.435 211.987 154.077 213.027 153.036C214.068 151.996 215.426 151.476 217.094 151.476H231.903C233.571 151.476 234.929 151.996 235.969 153.036C237.01 154.077 237.53 155.435 237.53 157.103V176.81ZM229.822 175.496V158.41H219.175V175.496H229.822ZM261.754 169.291H241.432V150.587H261.754V169.291ZM272.895 184.252H243.545V171.563H251.101V177.926H272.889V184.252H272.895ZM254.191 162.928V156.951H248.982V162.928H254.191ZM272.318 174.614H264.761V150.2H272.318V156.989H276.099V163.467H272.318V174.614ZM310.303 176.657H302.746V175.464H294.226V170.643H302.746V166.709L300.126 169.329H292.335V174.38H284.582V169.329H277.292V164.12H302.746V150.2H310.303V176.657ZM286.124 162.813C283.579 162.813 281.581 162.242 280.128 161.1C278.675 159.958 277.952 158.359 277.952 156.297C277.952 154.235 278.675 152.605 280.128 151.457C281.581 150.314 283.579 149.743 286.124 149.743H292.836C295.38 149.743 297.379 150.314 298.832 151.457C300.285 152.599 301.008 154.216 301.008 156.297C301.008 158.378 300.278 159.958 298.832 161.1C297.379 162.242 295.38 162.813 292.836 162.813H286.124ZM310.461 184.252H280.229V175.268H287.786V178.853H310.461V184.252ZM291.485 157.604C292.075 157.604 292.551 157.497 292.912 157.275C293.274 157.059 293.452 156.716 293.452 156.253C293.452 155.79 293.274 155.454 292.912 155.251C292.551 155.048 292.075 154.94 291.485 154.94H287.475C286.885 154.94 286.409 155.041 286.047 155.251C285.686 155.454 285.508 155.79 285.508 156.253C285.508 156.716 285.686 157.059 286.047 157.275C286.409 157.49 286.885 157.604 287.475 157.604H291.485Z",
    fill: "url(#paint3_linear_2132_129647)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M125.213 231.871C124.251 230.24 123.572 228.568 123.187 226.876C122.802 225.184 122.609 223.512 122.609 221.881C122.609 220.25 122.802 218.608 123.187 216.916C123.572 215.235 124.251 213.573 125.213 211.952H128.445C127.969 212.752 127.554 213.583 127.209 214.434C126.865 215.285 126.571 216.136 126.348 216.987C126.125 217.838 125.963 218.669 125.862 219.5C125.76 220.321 125.71 221.121 125.71 221.871C125.71 222.621 125.76 223.421 125.862 224.252C125.963 225.083 126.125 225.924 126.348 226.785C126.571 227.636 126.855 228.497 127.209 229.348C127.554 230.199 127.969 231.04 128.445 231.861H125.213V231.871Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M143.764 227.615C143.764 227.99 143.694 228.325 143.552 228.639C143.41 228.953 143.228 229.226 142.994 229.449C142.761 229.682 142.488 229.865 142.184 229.996C141.87 230.128 141.536 230.199 141.181 230.199H132.711C132.356 230.199 132.022 230.128 131.708 229.996C131.394 229.865 131.12 229.682 130.897 229.449C130.674 229.216 130.482 228.943 130.34 228.639C130.198 228.325 130.127 227.98 130.127 227.615V215.224C130.127 214.849 130.198 214.515 130.34 214.201C130.482 213.887 130.664 213.613 130.897 213.39C131.13 213.157 131.404 212.975 131.708 212.843C132.022 212.712 132.356 212.641 132.711 212.641H140.958C141.313 212.641 141.647 212.712 141.961 212.843C142.275 212.975 142.549 213.157 142.772 213.39C143.005 213.624 143.187 213.897 143.329 214.201C143.471 214.515 143.542 214.86 143.542 215.224V217.453H140.462V215.802C140.462 215.68 140.421 215.589 140.35 215.508C140.279 215.437 140.178 215.397 140.056 215.397H133.592C133.471 215.397 133.379 215.437 133.298 215.508C133.228 215.579 133.187 215.68 133.187 215.802V219.551H141.171C141.525 219.551 141.86 219.622 142.174 219.753C142.488 219.885 142.761 220.067 142.984 220.3C143.217 220.533 143.4 220.807 143.542 221.111C143.683 221.425 143.754 221.769 143.754 222.134V227.615H143.764ZM140.289 227.433C140.411 227.433 140.502 227.393 140.583 227.322C140.654 227.251 140.695 227.149 140.695 227.028V222.702C140.695 222.58 140.654 222.489 140.583 222.408C140.512 222.337 140.411 222.296 140.289 222.296H133.197V227.028C133.197 227.149 133.238 227.241 133.309 227.322C133.379 227.393 133.481 227.433 133.602 227.433H140.289Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M159.144 222.438H146.551V212.276H157.716V214.86H149.62V216.086H157.513V218.629H149.62V219.855H159.144V222.438ZM163.582 231.405H148.202V223.755H163.582V231.405ZM160.512 228.77V226.389H151.282V228.77H160.512ZM163.582 222.995H160.502V211.891H163.582V222.995Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M183.136 223.269C182.691 222.914 182.275 222.57 181.89 222.256C181.505 221.942 181.12 221.617 180.755 221.283C180.381 220.959 180.016 220.625 179.641 220.29C179.266 219.956 178.881 219.591 178.455 219.206C177.604 219.996 176.784 220.736 175.993 221.445C175.193 222.154 174.352 222.874 173.461 223.624L171.606 221.506C172.468 220.746 173.248 220.047 173.957 219.399C174.666 218.75 175.375 218.092 176.105 217.403C176.358 217.18 176.551 216.896 176.682 216.562C176.814 216.227 176.885 215.893 176.885 215.549V212.296H180.006V215.549C180.006 215.893 180.077 216.227 180.208 216.562C180.34 216.896 180.532 217.17 180.786 217.403C181.14 217.727 181.475 218.041 181.779 218.325C182.083 218.619 182.397 218.912 182.701 219.206C183.015 219.5 183.339 219.804 183.694 220.118C184.038 220.432 184.443 220.777 184.889 221.141L183.126 223.259L183.136 223.269ZM190.137 231.405H174.281V224.444H177.361V228.679H190.137V231.395V231.405ZM189.671 225.984H186.591V217.909H182.893V215.184H186.591V211.881H189.671V225.974V225.984Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M203.653 221.324H192.589V212.185H195.669V214.1H200.573V212.185H203.653V221.324ZM209.843 231.628H194.372V225.984H206.317V225.052H194.342V222.56H209.387V228.203H197.442V229.135H209.833V231.628H209.843ZM200.573 218.74V216.643H195.669V218.74H200.573ZM209.408 221.901H206.327V211.891H209.408V215.437H211.9V218.264H209.408V221.901Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M212.478 231.871C212.954 231.05 213.359 230.219 213.714 229.358C214.058 228.507 214.352 227.646 214.575 226.795C214.798 225.944 214.96 225.093 215.061 224.262C215.162 223.431 215.213 222.631 215.213 221.881C215.213 221.131 215.162 220.331 215.061 219.51C214.96 218.689 214.798 217.849 214.575 216.997C214.352 216.146 214.068 215.295 213.714 214.444C213.359 213.593 212.954 212.762 212.478 211.962H215.71C216.672 213.583 217.351 215.235 217.736 216.927C218.121 218.619 218.313 220.27 218.313 221.891C218.313 223.512 218.121 225.194 217.736 226.886C217.351 228.578 216.672 230.25 215.71 231.881H212.478V231.871Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M257.115 396.616C294.332 396.616 324.503 366.445 324.503 329.228C324.503 292.01 294.332 261.839 257.115 261.839C219.897 261.839 189.726 292.01 189.726 329.228C189.726 366.445 219.897 396.616 257.115 396.616Z",
    fill: "url(#paint4_radial_2132_129647)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M257.103 260.683C219.315 260.683 188.57 291.428 188.57 329.216C188.57 367.003 219.315 397.772 257.103 397.772C294.89 397.772 325.659 367.015 325.659 329.216C325.659 291.416 294.902 260.683 257.103 260.683ZM257.103 402.575C216.658 402.575 183.756 369.673 183.756 329.216C183.756 288.759 216.658 255.881 257.103 255.881C297.548 255.881 330.461 288.783 330.461 329.216C330.461 369.649 297.548 402.575 257.103 402.575Z",
    fill: "url(#paint5_linear_2132_129647)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M257.103 260.802C219.375 260.802 188.677 291.5 188.677 329.228C188.677 366.956 219.375 397.665 257.103 397.665C294.831 397.665 325.54 366.968 325.54 329.228C325.54 291.488 294.843 260.802 257.103 260.802ZM184.006 329.216C184.006 288.914 216.801 256.131 257.103 256.131C297.405 256.131 330.211 288.914 330.211 329.216C330.211 369.518 297.417 402.324 257.103 402.324C216.789 402.324 184.006 369.53 184.006 329.216Z",
    fill: "url(#paint6_linear_2132_129647)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M257.103 260.91C219.434 260.91 188.785 291.547 188.785 329.216C188.785 366.884 219.434 397.546 257.103 397.546C294.771 397.546 325.433 366.896 325.433 329.216C325.433 291.535 294.783 260.91 257.103 260.91ZM184.256 329.216C184.256 289.057 216.932 256.381 257.103 256.381C297.274 256.381 329.961 289.057 329.961 329.216C329.961 369.375 297.274 402.074 257.103 402.074C216.932 402.074 184.256 369.387 184.256 329.216Z",
    fill: "url(#paint7_linear_2132_129647)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M257.103 261.029C219.494 261.029 188.892 291.619 188.892 329.228C188.892 366.837 219.494 397.439 257.103 397.439C294.712 397.439 325.325 366.837 325.325 329.228C325.325 291.619 294.724 261.029 257.103 261.029ZM184.507 329.216C184.507 289.188 217.075 256.632 257.103 256.632C297.131 256.632 329.711 289.188 329.711 329.216C329.711 369.244 297.143 401.812 257.103 401.812C217.063 401.812 184.507 369.244 184.507 329.216Z",
    fill: "url(#paint8_linear_2132_129647)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M257.103 261.136C219.553 261.136 188.999 291.678 188.999 329.216C188.999 366.753 219.553 397.319 257.103 397.319C294.652 397.319 325.218 366.765 325.218 329.216C325.218 291.667 294.664 261.136 257.103 261.136ZM184.757 329.216C184.757 289.331 217.218 256.882 257.103 256.882C296.988 256.882 329.46 289.331 329.46 329.216C329.46 369.101 297 401.562 257.103 401.562C217.206 401.562 184.757 369.101 184.757 329.216Z",
    fill: "url(#paint9_linear_2132_129647)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M257.103 261.255C219.613 261.255 189.118 291.75 189.118 329.228C189.118 366.706 219.613 397.212 257.103 397.212C294.592 397.212 325.099 366.717 325.099 329.228C325.099 291.738 294.592 261.255 257.103 261.255ZM185.007 329.216C185.007 289.474 217.349 257.132 257.103 257.132C296.857 257.132 329.21 289.462 329.21 329.216C329.21 368.97 296.868 401.311 257.103 401.311C217.337 401.311 185.007 368.97 185.007 329.216Z",
    fill: "url(#paint10_linear_2132_129647)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M257.103 261.363C219.673 261.363 189.226 291.798 189.226 329.216C189.226 366.634 219.673 397.093 257.103 397.093C294.533 397.093 324.992 366.646 324.992 329.216C324.992 291.786 294.533 261.363 257.103 261.363ZM185.257 329.216C185.257 289.605 217.492 257.394 257.103 257.394C296.714 257.394 328.96 289.617 328.96 329.216C328.96 368.815 296.725 401.061 257.103 401.061C217.48 401.061 185.257 368.827 185.257 329.216Z",
    fill: "url(#paint11_linear_2132_129647)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M257.103 261.482C219.732 261.482 189.333 291.869 189.333 329.228C189.333 366.586 219.732 396.986 257.103 396.986C294.473 396.986 324.884 366.586 324.884 329.228C324.884 291.869 294.485 261.482 257.103 261.482ZM185.508 329.216C185.508 289.748 217.623 257.645 257.103 257.645C296.582 257.645 328.71 289.748 328.71 329.216C328.71 368.684 296.582 400.811 257.103 400.811C217.623 400.811 185.508 368.696 185.508 329.216Z",
    fill: "url(#paint12_linear_2132_129647)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M257.103 261.589C219.792 261.589 189.44 291.929 189.44 329.216C189.44 366.503 219.792 396.867 257.103 396.867C294.414 396.867 324.765 366.515 324.765 329.216C324.765 291.917 294.414 261.589 257.103 261.589ZM185.758 329.216C185.758 289.891 217.766 257.895 257.115 257.895C296.463 257.895 328.471 289.891 328.471 329.216C328.471 368.541 296.463 400.561 257.115 400.561C217.766 400.561 185.758 368.553 185.758 329.216Z",
    fill: "url(#paint13_linear_2132_129647)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M257.115 261.696C219.863 261.696 189.559 291.988 189.559 329.216C189.559 366.443 219.863 396.747 257.115 396.747C294.366 396.747 324.67 366.455 324.67 329.216C324.67 291.976 294.366 261.696 257.115 261.696ZM186.008 329.228C186.008 290.034 217.909 258.157 257.115 258.157C296.32 258.157 328.221 290.034 328.221 329.228C328.221 368.422 296.32 400.311 257.115 400.311C217.909 400.311 186.008 368.422 186.008 329.228Z",
    fill: "url(#paint14_linear_2132_129647)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M257.115 261.815C219.923 261.815 189.666 292.048 189.666 329.228C189.666 366.408 219.923 396.652 257.115 396.652C294.306 396.652 324.563 366.408 324.563 329.228C324.563 292.048 294.306 261.815 257.115 261.815ZM186.258 329.228C186.258 290.177 218.04 258.407 257.115 258.407C296.189 258.407 327.971 290.177 327.971 329.228C327.971 368.279 296.189 400.06 257.115 400.06C218.04 400.06 186.258 368.279 186.258 329.228Z",
    fill: "url(#paint15_linear_2132_129647)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M257.115 261.923C219.982 261.923 189.786 292.108 189.786 329.216C189.786 366.324 219.994 396.521 257.115 396.521C294.235 396.521 324.455 366.324 324.455 329.216C324.455 292.108 294.247 261.923 257.115 261.923ZM186.509 329.228C186.509 290.32 218.183 258.658 257.115 258.658C296.046 258.658 327.721 290.308 327.721 329.228C327.721 368.148 296.046 399.81 257.115 399.81C218.183 399.81 186.509 368.148 186.509 329.228Z",
    fill: "url(#paint16_linear_2132_129647)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M257.115 262.042C220.042 262.042 189.893 292.179 189.893 329.228C189.893 366.277 220.054 396.426 257.115 396.426C294.175 396.426 324.336 366.277 324.336 329.228C324.336 292.179 294.175 262.042 257.115 262.042ZM186.759 329.228C186.759 290.451 218.326 258.908 257.115 258.908C295.903 258.908 327.47 290.451 327.47 329.228C327.47 368.005 295.903 399.56 257.115 399.56C218.326 399.56 186.759 368.005 186.759 329.228Z",
    fill: "url(#paint17_linear_2132_129647)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M257.115 262.149C220.101 262.149 190 292.239 190 329.216C190 366.193 220.101 396.307 257.115 396.307C294.128 396.307 324.229 366.217 324.229 329.216C324.229 292.215 294.116 262.149 257.115 262.149ZM186.997 329.228C186.997 290.594 218.445 259.17 257.103 259.17C295.76 259.17 327.208 290.594 327.208 329.228C327.208 367.862 295.76 399.31 257.103 399.31C218.445 399.31 186.997 367.873 186.997 329.228Z",
    fill: "url(#paint18_linear_2132_129647)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M257.115 262.268C220.173 262.268 190.107 292.31 190.107 329.228C190.107 366.145 220.161 396.199 257.115 396.199C294.068 396.199 324.122 366.157 324.122 329.228C324.122 292.298 294.068 262.268 257.115 262.268ZM187.247 329.228C187.247 290.737 218.588 259.42 257.103 259.42C295.617 259.42 326.958 290.737 326.958 329.228C326.958 367.718 295.617 399.059 257.103 399.059C218.588 399.059 187.247 367.73 187.247 329.228Z",
    fill: "url(#paint19_linear_2132_129647)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M257.115 262.375C220.233 262.375 190.215 292.358 190.215 329.216C190.215 366.074 220.221 396.08 257.115 396.08C294.008 396.08 324.014 366.086 324.014 329.216C324.014 292.346 294.008 262.375 257.115 262.375ZM187.498 329.228C187.498 290.868 218.719 259.67 257.103 259.67C295.486 259.67 326.708 290.868 326.708 329.228C326.708 367.587 295.486 398.797 257.103 398.797C218.719 398.797 187.498 367.587 187.498 329.228Z",
    fill: "url(#paint20_linear_2132_129647)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M323.895 329.228C323.895 292.429 293.937 262.495 257.115 262.495C220.292 262.495 190.322 292.429 190.322 329.228C190.322 366.026 220.28 395.973 257.115 395.973C293.949 395.973 323.895 366.026 323.895 329.228ZM187.748 329.228C187.748 291.011 218.862 259.921 257.115 259.921C295.367 259.921 326.469 291.011 326.469 329.228C326.469 367.444 295.355 398.547 257.115 398.547C218.874 398.547 187.748 367.444 187.748 329.228Z",
    fill: "url(#paint21_linear_2132_129647)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M255.935 314.141H225.512V308.898H247.581V303.178H227.097V297.935H254.338V308.898H255.923V314.141H255.935ZM254.35 328.286H247.593V325.117L244.423 328.286H227.109V315.869H254.35V328.286ZM247.593 323.043V321.113H233.865V323.043H247.593Z",
    fill: "#BC912F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M275.013 314.106C273.822 313.307 272.642 312.473 271.474 311.627C270.318 310.781 269.186 309.828 268.114 308.767C267.005 309.78 265.861 310.721 264.682 311.591C263.502 312.461 262.227 313.355 260.868 314.249L257.007 309.661C258.294 308.695 259.498 307.766 260.606 306.872C261.726 305.978 262.763 305.013 263.728 303.977C264.05 303.655 264.253 303.345 264.348 303.047C264.443 302.749 264.491 302.356 264.491 301.879V297.839H271.736V301.843C271.736 302.284 271.784 302.666 271.879 302.976C271.975 303.297 272.165 303.619 272.463 303.941C273.405 304.954 274.406 305.907 275.466 306.825C276.527 307.73 277.647 308.672 278.85 309.637L275.025 314.118L275.013 314.106ZM280.662 315.035C281.853 315.035 282.89 315.214 283.76 315.583C284.63 315.953 285.357 316.453 285.917 317.085C286.477 317.716 286.894 318.455 287.18 319.289C287.454 320.124 287.597 321.005 287.597 321.923C287.597 322.841 287.454 323.722 287.168 324.557C286.882 325.391 286.453 326.13 285.881 326.761C285.309 327.393 284.57 327.893 283.689 328.263C282.807 328.632 281.758 328.811 280.566 328.811H266.362C265.17 328.811 264.133 328.632 263.275 328.263C262.417 327.893 261.702 327.393 261.154 326.761C260.606 326.13 260.189 325.391 259.927 324.557C259.665 323.722 259.534 322.841 259.534 321.923C259.534 321.005 259.677 320.124 259.951 319.289C260.225 318.455 260.642 317.716 261.214 317.085C261.774 316.453 262.501 315.953 263.371 315.583C264.241 315.214 265.277 315.035 266.469 315.035H280.674H280.662ZM279.113 323.21C279.637 323.21 280.066 323.091 280.376 322.864C280.686 322.638 280.841 322.328 280.841 321.935C280.841 321.542 280.686 321.232 280.388 320.982C280.09 320.743 279.661 320.624 279.113 320.624H268.006C267.458 320.624 267.029 320.743 266.731 320.982C266.433 321.22 266.278 321.542 266.278 321.935C266.278 322.328 266.433 322.638 266.743 322.864C267.053 323.091 267.47 323.21 268.006 323.21H279.113ZM286.429 314.249H279.673V297.828H286.429V302.582H289.814V308.374H286.429V314.237V314.249Z",
    fill: "#BC912F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M224.952 355.516C224.952 356.183 224.749 356.731 224.332 357.136C223.915 357.553 223.379 357.756 222.711 357.756H213.619C212.952 357.756 212.403 357.553 211.998 357.136C211.581 356.719 211.379 356.183 211.379 355.516V351.023H213.917V355.122C213.917 355.385 214.048 355.516 214.31 355.516H222.032C222.294 355.516 222.425 355.385 222.425 355.122V348.723C222.425 348.461 222.294 348.33 222.032 348.33H211.569V338.511H224.272V340.763H214.108V346.09H222.711C223.379 346.09 223.915 346.292 224.332 346.709C224.749 347.126 224.952 347.663 224.952 348.33V355.516Z",
    fill: "#BC912F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M241.349 355.516C241.349 356.183 241.146 356.731 240.729 357.136C240.312 357.553 239.776 357.756 239.108 357.756H230.171C229.504 357.756 228.955 357.553 228.55 357.136C228.133 356.719 227.931 356.183 227.931 355.516V340.763C227.931 340.096 228.133 339.559 228.55 339.142C228.967 338.725 229.504 338.523 230.171 338.523H239.108C239.776 338.523 240.312 338.725 240.729 339.142C241.146 339.559 241.349 340.096 241.349 340.763V355.516ZM238.417 355.516C238.679 355.516 238.811 355.385 238.811 355.123V341.144C238.811 340.882 238.679 340.751 238.417 340.751H230.838C230.576 340.751 230.445 340.882 230.445 341.144V355.123C230.445 355.385 230.576 355.516 230.838 355.516H238.417Z",
    fill: "#BC912F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M257.818 355.516C257.818 356.183 257.615 356.731 257.198 357.136C256.781 357.553 256.245 357.756 255.577 357.756H246.64C245.972 357.756 245.424 357.553 245.019 357.136C244.602 356.719 244.399 356.183 244.399 355.516V340.763C244.399 340.096 244.602 339.559 245.019 339.142C245.436 338.725 245.972 338.523 246.64 338.523H255.577C256.245 338.523 256.781 338.725 257.198 339.142C257.615 339.559 257.818 340.096 257.818 340.763V355.516ZM254.886 355.516C255.148 355.516 255.279 355.385 255.279 355.123V341.144C255.279 340.882 255.148 340.751 254.886 340.751H247.307C247.045 340.751 246.914 340.882 246.914 341.144V355.123C246.914 355.385 247.045 355.516 247.307 355.516H254.886Z",
    fill: "#BC912F"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M272.523 349.45H260.654V338.475H272.523V349.45ZM279.101 358.983H262.608V351.702H265.146V356.731H279.101V358.983ZM269.985 347.21V340.739H263.192V347.21H269.985ZM278.588 353.383H276.05V337.796H278.588V343.289H281.448V345.589H278.588V353.383Z",
    fill: "#BC912F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M297.965 349.236H291.423V353.001H288.885V349.236H283.069V346.983H297.977V349.236H297.965ZM296.738 343.563C296.476 344.052 296.07 344.481 295.51 344.85C294.95 345.22 294.271 345.506 293.449 345.708C292.626 345.911 291.673 346.018 290.577 346.018C289.48 346.018 288.503 345.923 287.693 345.708C286.883 345.506 286.191 345.22 285.643 344.85C285.095 344.481 284.678 344.052 284.404 343.551C284.13 343.051 283.999 342.515 283.999 341.931C283.999 341.347 284.13 340.799 284.404 340.31C284.678 339.81 285.083 339.381 285.643 339.011C286.191 338.642 286.883 338.356 287.693 338.141C288.503 337.927 289.469 337.82 290.577 337.82C291.685 337.82 292.626 337.927 293.449 338.141C294.271 338.356 294.962 338.642 295.51 339.011C296.058 339.381 296.476 339.81 296.75 340.31C297.024 340.811 297.155 341.347 297.155 341.931C297.155 342.515 297.012 343.063 296.738 343.563ZM302.732 358.983H285.5V352.87H288.039V356.85H302.72V358.972L302.732 358.983ZM293.616 343.265C294.283 342.896 294.617 342.443 294.617 341.919C294.617 341.395 294.283 340.942 293.616 340.56C292.948 340.179 291.935 339.988 290.589 339.988C289.242 339.988 288.229 340.179 287.562 340.56C286.895 340.942 286.561 341.395 286.561 341.919C286.561 342.443 286.895 342.884 287.562 343.265C288.229 343.635 289.242 343.826 290.589 343.826C291.935 343.826 292.948 343.635 293.616 343.265ZM302.219 354.61H299.681V352.87H294.307V350.725H299.681V337.796H302.219V354.61Z",
    fill: "#BC912F"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8204 569.932C121.038 569.932 151.209 539.761 151.209 502.543C151.209 465.326 121.038 435.155 83.8204 435.155C46.6028 435.155 16.4319 465.326 16.4319 502.543C16.4319 539.761 46.6028 569.932 83.8204 569.932Z",
    fill: "url(#paint22_radial_2132_129647)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8083 433.999C46.0206 433.999 15.2757 464.744 15.2757 502.531C15.2757 540.319 46.0206 571.088 83.8083 571.088C121.596 571.088 152.365 540.331 152.365 502.531C152.365 464.732 121.608 433.999 83.8083 433.999ZM83.8083 575.89C43.3632 575.89 10.4614 542.988 10.4614 502.531C10.4614 462.074 43.3632 429.196 83.8083 429.196C124.253 429.196 157.167 462.098 157.167 502.531C157.167 542.964 124.253 575.89 83.8083 575.89Z",
    fill: "url(#paint23_linear_2132_129647)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8083 434.118C46.0803 434.118 15.383 464.815 15.383 502.543C15.383 540.271 46.0803 570.98 83.8083 570.98C121.536 570.98 152.245 540.283 152.245 502.543C152.245 464.803 121.548 434.118 83.8083 434.118ZM10.7236 502.531C10.7236 462.229 43.5182 429.447 83.8202 429.447C124.122 429.447 156.929 462.229 156.929 502.531C156.929 542.833 124.134 575.64 83.8202 575.64C43.5063 575.64 10.7236 542.845 10.7236 502.531Z",
    fill: "url(#paint24_linear_2132_129647)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8083 434.225C46.1398 434.225 15.4903 464.863 15.4903 502.531C15.4903 540.2 46.1398 570.861 83.8083 570.861C121.477 570.861 152.138 540.212 152.138 502.531C152.138 464.851 121.489 434.225 83.8083 434.225ZM10.9739 502.531C10.9739 462.372 43.6493 429.697 83.8202 429.697C123.991 429.697 156.679 462.372 156.679 502.531C156.679 542.69 123.991 575.39 83.8202 575.39C43.6493 575.39 10.9739 542.702 10.9739 502.531Z",
    fill: "url(#paint25_linear_2132_129647)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8202 434.344C46.2114 434.344 15.6094 464.934 15.6094 502.543C15.6094 540.152 46.2114 570.754 83.8202 570.754C121.429 570.754 152.043 540.152 152.043 502.543C152.043 464.934 121.441 434.344 83.8202 434.344ZM11.2241 502.531C11.2241 462.503 43.7923 429.947 83.8202 429.947C123.848 429.947 156.428 462.503 156.428 502.531C156.428 542.559 123.86 575.127 83.8202 575.127C43.7804 575.127 11.2241 542.559 11.2241 502.531Z",
    fill: "url(#paint26_linear_2132_129647)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8202 434.452C46.2709 434.452 15.7166 464.994 15.7166 502.531C15.7166 540.069 46.2709 570.635 83.8202 570.635C121.369 570.635 151.936 540.081 151.936 502.531C151.936 464.982 121.381 434.452 83.8202 434.452ZM11.4624 502.531C11.4624 462.646 43.9233 430.197 83.8083 430.197C123.693 430.197 156.166 462.646 156.166 502.531C156.166 542.416 123.705 574.877 83.8083 574.877C43.9114 574.877 11.4624 542.416 11.4624 502.531Z",
    fill: "url(#paint27_linear_2132_129647)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8202 434.571C46.3305 434.571 15.8358 465.065 15.8358 502.543C15.8358 540.021 46.3305 570.528 83.8202 570.528C121.31 570.528 151.816 540.033 151.816 502.543C151.816 465.054 121.31 434.571 83.8202 434.571ZM11.7126 502.531C11.7126 462.789 44.0544 430.448 83.8083 430.448C123.562 430.448 155.916 462.777 155.916 502.531C155.916 542.285 123.574 574.627 83.8083 574.627C44.0425 574.627 11.7126 542.285 11.7126 502.531Z",
    fill: "url(#paint28_linear_2132_129647)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8202 434.678C46.3901 434.678 15.943 465.113 15.943 502.531C15.943 539.95 46.3901 570.409 83.8202 570.409C121.25 570.409 151.709 539.962 151.709 502.531C151.709 465.101 121.25 434.678 83.8202 434.678ZM11.9629 502.531C11.9629 462.921 44.1974 430.71 83.8083 430.71C123.419 430.71 155.666 462.933 155.666 502.531C155.666 542.13 123.431 574.377 83.8083 574.377C44.1855 574.377 11.9629 542.142 11.9629 502.531Z",
    fill: "url(#paint29_linear_2132_129647)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8202 434.797C46.4496 434.797 16.0503 465.185 16.0503 502.543C16.0503 539.902 46.4496 570.301 83.8202 570.301C121.191 570.301 151.602 539.902 151.602 502.543C151.602 465.185 121.203 434.797 83.8202 434.797ZM12.2131 502.531C12.2131 463.064 44.3284 430.96 83.8082 430.96C123.288 430.96 155.415 463.064 155.415 502.531C155.415 541.999 123.288 574.127 83.8082 574.127C44.3284 574.127 12.2131 542.011 12.2131 502.531Z",
    fill: "url(#paint30_linear_2132_129647)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8202 434.905C46.5092 434.905 16.1575 465.244 16.1575 502.531C16.1575 539.819 46.5092 570.182 83.8202 570.182C121.131 570.182 151.483 539.831 151.483 502.531C151.483 465.232 121.131 434.905 83.8202 434.905ZM12.4634 502.531C12.4634 463.207 44.4714 431.21 83.8202 431.21C123.169 431.21 155.177 463.207 155.177 502.531C155.177 541.856 123.169 573.876 83.8202 573.876C44.4714 573.876 12.4634 541.868 12.4634 502.531Z",
    fill: "url(#paint31_linear_2132_129647)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8202 435.012C46.5688 435.012 16.2648 465.304 16.2648 502.531C16.2648 539.759 46.5688 570.063 83.8202 570.063C121.072 570.063 151.376 539.771 151.376 502.531C151.376 465.292 121.072 435.012 83.8202 435.012ZM12.7136 502.543C12.7136 463.35 44.6145 431.473 83.8202 431.473C123.026 431.473 154.927 463.35 154.927 502.543C154.927 541.737 123.026 573.626 83.8202 573.626C44.6145 573.626 12.7136 541.737 12.7136 502.543Z",
    fill: "url(#paint32_linear_2132_129647)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8202 435.131C46.6284 435.131 16.372 465.363 16.372 502.543C16.372 539.723 46.6284 569.968 83.8202 569.968C121.012 569.968 151.268 539.723 151.268 502.543C151.268 465.363 121.012 435.131 83.8202 435.131ZM12.9639 502.543C12.9639 463.493 44.7455 431.723 83.8202 431.723C122.895 431.723 154.676 463.493 154.676 502.543C154.676 541.594 122.895 573.376 83.8202 573.376C44.7455 573.376 12.9639 541.594 12.9639 502.543Z",
    fill: "url(#paint33_linear_2132_129647)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8201 435.238C46.6879 435.238 16.4912 465.423 16.4912 502.531C16.4912 539.64 46.6998 569.837 83.8201 569.837C120.94 569.837 151.161 539.64 151.161 502.531C151.161 465.423 120.952 435.238 83.8201 435.238ZM13.2141 502.543C13.2141 463.636 44.8885 431.973 83.8201 431.973C122.752 431.973 154.426 463.624 154.426 502.543C154.426 541.463 122.752 573.126 83.8201 573.126C44.8885 573.126 13.2141 541.463 13.2141 502.543Z",
    fill: "url(#paint34_linear_2132_129647)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8202 435.357C46.7475 435.357 16.5984 465.495 16.5984 502.543C16.5984 539.592 46.7594 569.741 83.8202 569.741C120.881 569.741 151.042 539.592 151.042 502.543C151.042 465.495 120.881 435.357 83.8202 435.357ZM13.4644 502.543C13.4644 463.767 45.0315 432.223 83.8202 432.223C122.609 432.223 154.176 463.767 154.176 502.543C154.176 541.32 122.609 572.875 83.8202 572.875C45.0315 572.875 13.4644 541.32 13.4644 502.543Z",
    fill: "url(#paint35_linear_2132_129647)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8201 435.465C46.8071 435.465 16.7057 465.554 16.7057 502.531C16.7057 539.509 46.819 569.622 83.8201 569.622C120.821 569.622 150.935 539.533 150.935 502.531C150.935 465.53 120.821 435.465 83.8201 435.465ZM13.7146 502.543C13.7146 463.91 45.1626 432.485 83.8201 432.485C122.478 432.485 153.926 463.91 153.926 502.543C153.926 541.177 122.478 572.625 83.8201 572.625C45.1626 572.625 13.7146 541.189 13.7146 502.543Z",
    fill: "url(#paint36_linear_2132_129647)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8204 435.584C46.8788 435.584 16.8131 465.626 16.8131 502.543C16.8131 539.461 46.8669 569.515 83.8204 569.515C120.774 569.515 150.828 539.473 150.828 502.543C150.828 465.614 120.774 435.584 83.8204 435.584ZM13.9651 502.543C13.9651 464.053 45.3058 432.736 83.8204 432.736C122.335 432.736 153.676 464.053 153.676 502.543C153.676 541.034 122.335 572.375 83.8204 572.375C45.3058 572.375 13.9651 541.046 13.9651 502.543Z",
    fill: "url(#paint37_linear_2132_129647)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8204 435.691C46.9384 435.691 16.9204 465.673 16.9204 502.531C16.9204 539.39 46.9265 569.396 83.8204 569.396C120.714 569.396 150.708 539.401 150.708 502.531C150.708 465.661 120.702 435.691 83.8204 435.691ZM14.2153 502.543C14.2153 464.184 45.4369 432.986 83.8204 432.986C122.204 432.986 153.425 464.184 153.425 502.543C153.425 540.903 122.204 572.113 83.8204 572.113C45.4369 572.113 14.2153 540.903 14.2153 502.543Z",
    fill: "url(#paint38_linear_2132_129647)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M150.601 502.543C150.601 465.745 120.643 435.81 83.8204 435.81C46.998 435.81 17.0276 465.745 17.0276 502.543C17.0276 539.342 46.9861 569.288 83.8204 569.288C120.655 569.288 150.601 539.342 150.601 502.543ZM14.4656 502.543C14.4656 464.327 45.5799 433.236 83.8323 433.236C122.085 433.236 153.187 464.327 153.187 502.543C153.187 540.76 122.073 571.862 83.8323 571.862C45.5918 571.862 14.4656 540.76 14.4656 502.543Z",
    fill: "url(#paint39_linear_2132_129647)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2401 490.877H32.8169V485.741H63.2401V490.877ZM55.0295 470.797C56.1735 470.797 57.2102 470.976 58.1159 471.334C59.0216 471.691 59.7843 472.18 60.4039 472.799C61.0236 473.419 61.5002 474.146 61.8339 474.968C62.1676 475.79 62.3344 476.672 62.3344 477.59C62.3344 478.507 62.1676 479.377 61.8339 480.211C61.5002 481.034 61.0236 481.761 60.4039 482.38C59.7843 483 59.0216 483.489 58.1159 483.846C57.2102 484.204 56.1735 484.382 55.0295 484.382H41.0275C39.8716 484.382 38.8467 484.204 37.9411 483.846C37.0354 483.489 36.2727 483 35.6531 482.38C35.0334 481.761 34.5568 481.034 34.2231 480.211C33.8894 479.389 33.7226 478.507 33.7226 477.59C33.7226 476.672 33.8894 475.802 34.2231 474.968C34.5568 474.146 35.0334 473.419 35.6531 472.799C36.2727 472.18 37.0354 471.691 37.9411 471.334C38.8467 470.976 39.8716 470.797 41.0275 470.797H55.0295ZM61.7981 501.602H34.4137V492.295H41.1705V496.466H61.7981V501.602ZM53.5876 479.318C54.1596 479.318 54.6363 479.163 55.0176 478.829C55.3989 478.507 55.5896 478.09 55.5896 477.59C55.5896 477.089 55.3989 476.672 55.0176 476.35C54.6363 476.029 54.1596 475.874 53.5876 475.874H42.4813C41.9093 475.874 41.4326 476.041 41.0513 476.35C40.67 476.672 40.4793 477.089 40.4793 477.59C40.4793 478.09 40.67 478.507 41.0513 478.829C41.4326 479.151 41.9093 479.318 42.4813 479.318H53.5876Z",
    fill: "#606060"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3188 487.421C81.1271 486.623 79.9473 485.789 78.7795 484.943C77.6117 484.096 76.4915 483.143 75.419 482.083C74.3108 483.095 73.1668 484.037 71.987 484.907C70.8073 485.777 69.5322 486.67 68.1737 487.564L64.3127 482.976C65.5997 482.011 66.8033 481.082 67.9116 480.188C69.0317 479.294 70.0685 478.329 71.0337 477.292C71.3555 476.97 71.558 476.66 71.6534 476.363C71.7487 476.065 71.7964 475.671 71.7964 475.195V471.155H79.0417V475.159C79.0417 475.6 79.0893 475.981 79.1847 476.291C79.28 476.613 79.4707 476.935 79.7686 477.256C80.71 478.269 81.711 479.223 82.7716 480.14C83.8322 481.046 84.9523 481.987 86.1559 482.952L82.3307 487.433L82.3188 487.421ZM87.9672 488.351C89.1589 488.351 90.1956 488.529 91.0656 488.899C91.9355 489.268 92.6624 489.769 93.2225 490.4C93.7825 491.032 94.2115 491.771 94.4856 492.605C94.7597 493.439 94.9027 494.321 94.9027 495.238C94.9027 496.156 94.7597 497.038 94.4737 497.872C94.1877 498.706 93.7587 499.445 93.1867 500.077C92.6147 500.708 91.8759 501.209 90.9941 501.578C90.1122 501.948 89.0636 502.126 87.8719 502.126H73.6673C72.4756 502.126 71.4389 501.948 70.5809 501.578C69.7229 501.209 69.0079 500.708 68.4597 500.077C67.9115 499.445 67.4945 498.706 67.2323 497.872C66.9701 497.038 66.8391 496.156 66.8391 495.238C66.8391 494.321 66.9821 493.439 67.2562 492.605C67.5302 491.771 67.9473 491.032 68.5193 490.4C69.0794 489.769 69.8063 489.268 70.6762 488.899C71.5461 488.529 72.5829 488.351 73.7745 488.351H87.9792H87.9672ZM86.4181 496.525C86.9424 496.525 87.3714 496.406 87.6812 496.18C87.9911 495.954 88.146 495.644 88.146 495.25C88.146 494.857 87.9911 494.547 87.6932 494.297C87.3953 494.059 86.9662 493.94 86.4181 493.94H75.3118C74.7636 493.94 74.3346 494.059 74.0367 494.297C73.7388 494.535 73.5839 494.857 73.5839 495.25C73.5839 495.644 73.7388 495.954 74.0486 496.18C74.3584 496.406 74.7755 496.525 75.3118 496.525H86.4181ZM93.7349 487.564H86.9782V471.143H93.7349V475.898H97.1192V481.689H93.7349V487.552V487.564Z",
    fill: "#606060"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M51.693 531.072H38.0842V524.649C38.0842 523.862 38.2034 523.266 38.4298 522.849C38.6562 522.432 39.0852 522.134 39.7287 521.956L48.4517 520.24C48.7138 520.18 48.8449 519.965 48.8449 519.632V514.448C48.8449 514.186 48.7138 514.055 48.4517 514.055H41.2421C40.98 514.055 40.8489 514.186 40.8489 514.448V518.214H38.3106V514.055C38.3106 513.387 38.5132 512.851 38.9303 512.434C39.3474 512.017 39.8836 511.814 40.551 511.814H49.1309C49.7983 511.814 50.3345 512.017 50.7516 512.434C51.1687 512.851 51.3713 513.387 51.3713 514.055V519.501C51.3713 520.287 51.2402 520.895 50.9899 521.324C50.7397 521.753 50.2988 522.063 49.6791 522.242L41.0038 523.898C40.7416 523.957 40.6105 524.16 40.6105 524.482V528.808H51.6811V531.06L51.693 531.072Z",
    fill: "#606060"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1259 528.831C68.1259 529.499 67.9233 530.047 67.5062 530.452C67.0892 530.869 66.5529 531.072 65.8856 531.072H56.9481C56.2808 531.072 55.7445 530.869 55.3275 530.452C54.9104 530.035 54.7078 529.499 54.7078 528.831V514.079C54.7078 513.411 54.9104 512.875 55.3275 512.458C55.7445 512.041 56.2808 511.838 56.9481 511.838H65.8856C66.5529 511.838 67.0892 512.041 67.5062 512.458C67.9233 512.875 68.1259 513.411 68.1259 514.079V528.831ZM65.1944 528.831C65.4566 528.831 65.5877 528.7 65.5877 528.438V514.46C65.5877 514.198 65.4566 514.067 65.1944 514.067H57.6154C57.3533 514.067 57.2222 514.198 57.2222 514.46V528.438C57.2222 528.7 57.3533 528.831 57.6154 528.831H65.1944Z",
    fill: "#606060"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6066 528.831C84.6066 529.499 84.404 530.047 83.9869 530.452C83.5698 530.869 83.0336 531.072 82.3663 531.072H73.4288C72.7615 531.072 72.2252 530.869 71.8081 530.452C71.391 530.035 71.1885 529.499 71.1885 528.831V514.079C71.1885 513.411 71.391 512.875 71.8081 512.458C72.2252 512.041 72.7615 511.838 73.4288 511.838H82.3663C83.0336 511.838 83.5698 512.041 83.9869 512.458C84.404 512.875 84.6066 513.411 84.6066 514.079V528.831ZM81.6751 528.831C81.9373 528.831 82.0684 528.7 82.0684 528.438V514.46C82.0684 514.198 81.9373 514.067 81.6751 514.067H74.0961C73.834 514.067 73.7029 514.198 73.7029 514.46V528.438C73.7029 528.7 73.834 528.831 74.0961 528.831H81.6751Z",
    fill: "#606060"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3119 522.766H87.4429V511.791H99.3119V522.766ZM105.878 532.299H89.3853V525.018H91.9235V530.047H105.878V532.299ZM96.7736 520.525V514.055H89.9811V520.525H96.7736ZM105.365 526.698H102.827V511.111H105.365V516.605H108.225V518.905H105.365V526.698Z",
    fill: "#606060"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M124.742 522.551H118.188V526.317H115.65V522.551H109.834V520.299H124.742V522.551ZM123.526 516.879C123.264 517.368 122.859 517.797 122.311 518.166C121.763 518.535 121.072 518.821 120.249 519.024C119.427 519.227 118.474 519.334 117.377 519.334C116.281 519.334 115.304 519.238 114.494 519.024C113.683 518.809 112.992 518.535 112.444 518.166C111.896 517.797 111.479 517.368 111.205 516.867C110.931 516.367 110.799 515.83 110.799 515.246C110.799 514.662 110.931 514.114 111.205 513.626C111.479 513.125 111.884 512.696 112.444 512.327C112.992 511.957 113.683 511.671 114.494 511.457C115.304 511.242 116.269 511.135 117.377 511.135C118.486 511.135 119.427 511.242 120.249 511.457C121.072 511.671 121.763 511.957 122.311 512.327C122.859 512.696 123.276 513.125 123.55 513.626C123.824 514.126 123.955 514.662 123.955 515.246C123.955 515.83 123.812 516.378 123.538 516.879H123.526ZM129.509 532.299H112.277V526.186H114.815V530.166H129.497V532.287L129.509 532.299ZM120.392 516.581C121.06 516.212 121.393 515.759 121.393 515.234C121.393 514.71 121.06 514.257 120.392 513.876C119.725 513.495 118.712 513.304 117.366 513.304C116.019 513.304 115.006 513.495 114.339 513.876C113.671 514.257 113.338 514.71 113.338 515.234C113.338 515.759 113.671 516.2 114.339 516.581C115.006 516.95 116.019 517.141 117.366 517.141C118.712 517.141 119.725 516.95 120.392 516.581ZM128.996 527.926H126.458V526.186H121.084V524.041H126.458V511.111H128.996V527.926Z",
    fill: "#606060"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M110.096 501.006H107.856L105.163 497.395L102.494 501.006H100.253L104.102 495.965L100.527 491.521H102.768L105.175 494.535L107.594 491.521H109.834L106.235 495.965L110.096 501.006Z",
    fill: "#606060"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M121.417 501.006H111.36V496.251C111.36 495.679 111.443 495.226 111.61 494.929C111.777 494.619 112.098 494.404 112.563 494.273L119.01 493.01C119.201 492.962 119.296 492.807 119.296 492.557V488.732C119.296 488.541 119.201 488.446 119.01 488.446H113.683C113.493 488.446 113.397 488.541 113.397 488.732V491.508H111.515V488.434C111.515 487.945 111.669 487.54 111.979 487.23C112.289 486.921 112.682 486.766 113.183 486.766H119.523C120.011 486.766 120.416 486.921 120.726 487.23C121.036 487.54 121.191 487.933 121.191 488.434V492.462C121.191 493.034 121.096 493.487 120.917 493.808C120.726 494.13 120.404 494.357 119.951 494.488L113.54 495.715C113.35 495.763 113.254 495.906 113.254 496.144V499.338H121.441V500.994L121.417 501.006Z",
    fill: "#606060"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M134.144 494.559H123.836V486.575H132.988V488.231H125.707V489.745H132.809V491.353H125.707V492.891H134.144V494.547V494.559ZM137.385 501.9H125.29V495.941H137.385V501.9ZM135.503 500.303V497.526H127.161V500.303H135.503ZM137.385 495.357H135.503V486.253H137.385V495.357Z",
    fill: "#606060"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M256.385 569.932C293.602 569.932 323.773 539.761 323.773 502.543C323.773 465.326 293.602 435.155 256.385 435.155C219.167 435.155 188.996 465.326 188.996 502.543C188.996 539.761 219.167 569.932 256.385 569.932Z",
    fill: "url(#paint40_radial_2132_129647)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 433.999C218.597 433.999 187.852 464.744 187.852 502.531C187.852 540.319 218.597 571.088 256.384 571.088C294.172 571.088 324.941 540.331 324.941 502.531C324.941 464.732 294.184 433.999 256.384 433.999ZM256.384 575.89C215.939 575.89 183.038 542.988 183.038 502.531C183.038 462.074 215.939 429.196 256.384 429.196C296.829 429.196 329.743 462.098 329.743 502.531C329.743 542.964 296.829 575.89 256.384 575.89Z",
    fill: "url(#paint41_linear_2132_129647)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 434.118C218.656 434.118 187.959 464.815 187.959 502.543C187.959 540.271 218.656 570.98 256.384 570.98C294.112 570.98 324.822 540.283 324.822 502.543C324.822 464.803 294.124 434.118 256.384 434.118ZM183.288 502.531C183.288 462.229 216.082 429.447 256.384 429.447C296.686 429.447 329.493 462.229 329.493 502.531C329.493 542.833 296.698 575.64 256.384 575.64C216.07 575.64 183.288 542.845 183.288 502.531Z",
    fill: "url(#paint42_linear_2132_129647)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 434.225C218.716 434.225 188.066 464.863 188.066 502.531C188.066 540.2 218.716 570.861 256.384 570.861C294.053 570.861 324.714 540.212 324.714 502.531C324.714 464.851 294.065 434.225 256.384 434.225ZM183.538 502.531C183.538 462.372 216.213 429.697 256.384 429.697C296.555 429.697 329.243 462.372 329.243 502.531C329.243 542.69 296.555 575.39 256.384 575.39C216.213 575.39 183.538 542.702 183.538 502.531Z",
    fill: "url(#paint43_linear_2132_129647)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 434.344C218.776 434.344 188.174 464.934 188.174 502.543C188.174 540.152 218.776 570.754 256.384 570.754C293.993 570.754 324.607 540.152 324.607 502.543C324.607 464.934 294.005 434.344 256.384 434.344ZM183.788 502.531C183.788 462.503 216.356 429.947 256.384 429.947C296.412 429.947 328.993 462.503 328.993 502.531C328.993 542.559 296.424 575.127 256.384 575.127C216.345 575.127 183.788 542.559 183.788 502.531Z",
    fill: "url(#paint44_linear_2132_129647)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 434.452C218.835 434.452 188.281 464.994 188.281 502.531C188.281 540.069 218.835 570.635 256.384 570.635C293.934 570.635 324.5 540.081 324.5 502.531C324.5 464.982 293.946 434.452 256.384 434.452ZM184.039 502.531C184.039 462.646 216.499 430.197 256.384 430.197C296.269 430.197 328.742 462.646 328.742 502.531C328.742 542.416 296.281 574.877 256.384 574.877C216.488 574.877 184.039 542.416 184.039 502.531Z",
    fill: "url(#paint45_linear_2132_129647)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 434.571C218.895 434.571 188.4 465.065 188.4 502.543C188.4 540.021 218.895 570.528 256.384 570.528C293.874 570.528 324.381 540.033 324.381 502.543C324.381 465.054 293.874 434.571 256.384 434.571ZM184.289 502.531C184.289 462.789 216.631 430.448 256.384 430.448C296.138 430.448 328.492 462.777 328.492 502.531C328.492 542.285 296.138 574.627 256.384 574.627C216.631 574.627 184.289 542.285 184.289 502.531Z",
    fill: "url(#paint46_linear_2132_129647)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 434.678C218.954 434.678 188.507 465.113 188.507 502.531C188.507 539.95 218.954 570.409 256.384 570.409C293.815 570.409 324.273 539.962 324.273 502.531C324.273 465.101 293.815 434.678 256.384 434.678ZM184.539 502.531C184.539 462.921 216.774 430.71 256.384 430.71C295.995 430.71 328.242 462.933 328.242 502.531C328.242 542.13 296.007 574.377 256.384 574.377C216.762 574.377 184.539 542.142 184.539 502.531Z",
    fill: "url(#paint47_linear_2132_129647)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 434.797C219.014 434.797 188.615 465.185 188.615 502.543C188.615 539.902 219.014 570.301 256.384 570.301C293.755 570.301 324.166 539.902 324.166 502.543C324.166 465.185 293.767 434.797 256.384 434.797ZM184.789 502.531C184.789 463.064 216.905 430.96 256.384 430.96C295.864 430.96 327.991 463.064 327.991 502.531C327.991 541.999 295.864 574.127 256.384 574.127C216.905 574.127 184.789 542.011 184.789 502.531Z",
    fill: "url(#paint48_linear_2132_129647)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 434.905C219.073 434.905 188.722 465.244 188.722 502.531C188.722 539.819 219.073 570.182 256.384 570.182C293.695 570.182 324.047 539.831 324.047 502.531C324.047 465.232 293.695 434.905 256.384 434.905ZM185.04 502.531C185.04 463.207 217.048 431.21 256.396 431.21C295.745 431.21 327.753 463.207 327.753 502.531C327.753 541.856 295.745 573.876 256.396 573.876C217.048 573.876 185.04 541.868 185.04 502.531Z",
    fill: "url(#paint49_linear_2132_129647)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 435.012C219.133 435.012 188.829 465.304 188.829 502.531C188.829 539.759 219.133 570.063 256.384 570.063C293.636 570.063 323.94 539.771 323.94 502.531C323.94 465.292 293.636 435.012 256.384 435.012ZM185.278 502.543C185.278 463.35 217.179 431.473 256.384 431.473C295.59 431.473 327.491 463.35 327.491 502.543C327.491 541.737 295.59 573.626 256.384 573.626C217.179 573.626 185.278 541.737 185.278 502.543Z",
    fill: "url(#paint50_linear_2132_129647)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 435.131C219.193 435.131 188.936 465.363 188.936 502.543C188.936 539.723 219.193 569.968 256.384 569.968C293.576 569.968 323.832 539.723 323.832 502.543C323.832 465.363 293.576 435.131 256.384 435.131ZM185.528 502.543C185.528 463.493 217.31 431.723 256.384 431.723C295.459 431.723 327.241 463.493 327.241 502.543C327.241 541.594 295.459 573.376 256.384 573.376C217.31 573.376 185.528 541.594 185.528 502.543Z",
    fill: "url(#paint51_linear_2132_129647)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 435.238C219.252 435.238 189.055 465.423 189.055 502.531C189.055 539.64 219.264 569.837 256.384 569.837C293.505 569.837 323.725 539.64 323.725 502.531C323.725 465.423 293.517 435.238 256.384 435.238ZM185.778 502.543C185.778 463.636 217.453 431.973 256.384 431.973C295.316 431.973 326.99 463.624 326.99 502.543C326.99 541.463 295.316 573.126 256.384 573.126C217.453 573.126 185.778 541.463 185.778 502.543Z",
    fill: "url(#paint52_linear_2132_129647)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 435.357C219.312 435.357 189.163 465.495 189.163 502.543C189.163 539.592 219.324 569.741 256.384 569.741C293.445 569.741 323.606 539.592 323.606 502.543C323.606 465.495 293.445 435.357 256.384 435.357ZM186.029 502.543C186.029 463.767 217.596 432.223 256.384 432.223C295.173 432.223 326.74 463.767 326.74 502.543C326.74 541.32 295.173 572.875 256.384 572.875C217.596 572.875 186.029 541.32 186.029 502.543Z",
    fill: "url(#paint53_linear_2132_129647)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 435.465C219.371 435.465 189.27 465.554 189.27 502.531C189.27 539.509 219.371 569.622 256.384 569.622C293.397 569.622 323.499 539.533 323.499 502.531C323.499 465.53 293.385 435.465 256.384 435.465ZM186.279 502.543C186.279 463.91 217.727 432.485 256.384 432.485C295.042 432.485 326.49 463.91 326.49 502.543C326.49 541.177 295.042 572.625 256.384 572.625C217.727 572.625 186.279 541.189 186.279 502.543Z",
    fill: "url(#paint54_linear_2132_129647)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 435.584C219.443 435.584 189.377 465.626 189.377 502.543C189.377 539.461 219.431 569.515 256.384 569.515C293.338 569.515 323.392 539.473 323.392 502.543C323.392 465.614 293.338 435.584 256.384 435.584ZM186.529 502.543C186.529 464.053 217.87 432.736 256.384 432.736C294.899 432.736 326.24 464.053 326.24 502.543C326.24 541.034 294.899 572.375 256.384 572.375C217.87 572.375 186.529 541.046 186.529 502.543Z",
    fill: "url(#paint55_linear_2132_129647)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M256.384 435.691C219.502 435.691 189.484 465.673 189.484 502.531C189.484 539.39 219.49 569.396 256.384 569.396C293.278 569.396 323.284 539.401 323.284 502.531C323.284 465.661 293.278 435.691 256.384 435.691ZM186.779 502.543C186.779 464.184 218.001 432.986 256.384 432.986C294.768 432.986 325.989 464.184 325.989 502.543C325.989 540.903 294.768 572.113 256.384 572.113C218.001 572.113 186.779 540.903 186.779 502.543Z",
    fill: "url(#paint56_linear_2132_129647)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M323.177 502.543C323.177 465.745 293.219 435.81 256.396 435.81C219.574 435.81 189.604 465.745 189.604 502.543C189.604 539.342 219.562 569.288 256.396 569.288C293.231 569.288 323.177 539.342 323.177 502.543ZM187.03 502.543C187.03 464.327 218.144 433.236 256.396 433.236C294.649 433.236 325.751 464.327 325.751 502.543C325.751 540.76 294.637 571.862 256.396 571.862C218.156 571.862 187.03 540.76 187.03 502.543Z",
    fill: "url(#paint57_linear_2132_129647)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M234.72 489.53H204.297V484.704H215.642V482.94H205.882V471.25H233.123V476.076H212.639V478.114H233.505V482.94H223.364V484.704H234.708V489.53H234.72ZM227.129 490.531C228.321 490.531 229.358 490.686 230.216 490.996C231.074 491.306 231.789 491.723 232.349 492.259C232.909 492.784 233.338 493.415 233.612 494.118C233.886 494.833 234.029 495.584 234.029 496.359C234.029 497.133 233.886 497.884 233.6 498.587C233.314 499.29 232.885 499.898 232.301 500.434C231.729 500.958 231.002 501.387 230.132 501.697C229.262 502.007 228.226 502.162 227.034 502.162H211.888C210.696 502.162 209.671 502.007 208.813 501.697C207.967 501.387 207.264 500.97 206.704 500.434C206.156 499.91 205.739 499.29 205.477 498.587C205.215 497.884 205.084 497.145 205.084 496.359C205.084 495.572 205.227 494.833 205.501 494.118C205.775 493.403 206.192 492.784 206.764 492.259C207.324 491.735 208.039 491.306 208.897 490.996C209.755 490.686 210.792 490.531 211.983 490.531H227.129ZM225.616 497.217C226.14 497.217 226.569 497.145 226.879 496.99C227.189 496.835 227.344 496.633 227.344 496.347C227.344 495.751 226.772 495.453 225.616 495.453H213.544C212.4 495.453 211.817 495.751 211.817 496.347C211.817 496.621 211.971 496.835 212.281 496.99C212.591 497.133 213.008 497.217 213.544 497.217H225.616Z",
    fill: "#8E6545"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M253.787 487.421C252.595 486.623 251.415 485.789 250.248 484.943C249.08 484.096 247.971 483.143 246.887 482.083C245.779 483.095 244.635 484.037 243.455 484.907C242.275 485.777 241 486.67 239.642 487.564L235.781 482.976C237.068 482.011 238.271 481.082 239.38 480.188C240.5 479.294 241.537 478.329 242.502 477.292C242.824 476.97 243.026 476.66 243.121 476.363C243.217 476.065 243.264 475.671 243.264 475.195V471.155H250.51V475.159C250.51 475.6 250.557 475.981 250.653 476.291C250.748 476.613 250.939 476.935 251.237 477.256C252.178 478.269 253.179 479.223 254.24 480.14C255.3 481.046 256.42 481.987 257.624 482.952L253.799 487.433L253.787 487.421ZM259.447 488.351C260.639 488.351 261.676 488.529 262.546 488.899C263.415 489.268 264.142 489.769 264.702 490.4C265.263 491.032 265.692 491.771 265.966 492.605C266.24 493.439 266.383 494.321 266.383 495.238C266.383 496.156 266.24 497.038 265.954 497.872C265.668 498.706 265.239 499.445 264.667 500.077C264.095 500.708 263.356 501.209 262.474 501.578C261.592 501.948 260.544 502.126 259.352 502.126H245.147C243.956 502.126 242.919 501.948 242.061 501.578C241.203 501.209 240.488 500.708 239.94 500.077C239.391 499.445 238.974 498.706 238.712 497.872C238.45 497.038 238.319 496.156 238.319 495.238C238.319 494.321 238.462 493.439 238.736 492.605C239.01 491.771 239.427 491.032 239.999 490.4C240.559 489.769 241.286 489.268 242.156 488.899C243.026 488.529 244.063 488.351 245.254 488.351H259.459H259.447ZM257.886 496.525C258.41 496.525 258.839 496.406 259.149 496.18C259.459 495.954 259.614 495.644 259.614 495.25C259.614 494.857 259.459 494.547 259.161 494.297C258.863 494.059 258.434 493.94 257.886 493.94H246.78C246.232 493.94 245.803 494.059 245.505 494.297C245.207 494.535 245.052 494.857 245.052 495.25C245.052 495.644 245.207 495.954 245.517 496.18C245.826 496.406 246.244 496.525 246.78 496.525H257.886ZM265.203 487.564H258.446V471.143H265.203V475.898H268.587V481.689H265.203V487.552V487.564Z",
    fill: "#8E6545"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M218.573 531.072H216.035V514.067H212.913V511.814H218.585V531.072H218.573Z",
    fill: "#8E6545"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M235.471 528.831C235.471 529.499 235.268 530.047 234.851 530.452C234.434 530.869 233.898 531.072 233.231 531.072H224.293C223.626 531.072 223.09 530.869 222.672 530.452C222.255 530.035 222.053 529.499 222.053 528.831V514.079C222.053 513.411 222.255 512.875 222.672 512.458C223.09 512.041 223.626 511.838 224.293 511.838H233.231C233.898 511.838 234.434 512.041 234.851 512.458C235.268 512.875 235.471 513.411 235.471 514.079V528.831ZM232.539 528.831C232.802 528.831 232.933 528.7 232.933 528.438V514.46C232.933 514.198 232.802 514.067 232.539 514.067H224.96C224.698 514.067 224.567 514.198 224.567 514.46V528.438C224.567 528.7 224.698 528.831 224.96 528.831H232.539Z",
    fill: "#8E6545"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M251.94 528.831C251.94 529.499 251.737 530.047 251.32 530.452C250.903 530.869 250.367 531.072 249.699 531.072H240.762C240.094 531.072 239.558 530.869 239.141 530.452C238.724 530.035 238.521 529.499 238.521 528.831V514.079C238.521 513.411 238.724 512.875 239.141 512.458C239.558 512.041 240.094 511.838 240.762 511.838H249.699C250.367 511.838 250.903 512.041 251.32 512.458C251.737 512.875 251.94 513.411 251.94 514.079V528.831ZM249.008 528.831C249.27 528.831 249.401 528.7 249.401 528.438V514.46C249.401 514.198 249.27 514.067 249.008 514.067H241.429C241.167 514.067 241.036 514.198 241.036 514.46V528.438C241.036 528.7 241.167 528.831 241.429 528.831H249.008Z",
    fill: "#8E6545"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M266.657 522.766H254.788V511.791H266.657V522.766ZM273.223 532.299H256.73V525.018H259.269V530.047H273.223V532.299ZM264.119 520.525V514.055H257.326V520.525H264.119ZM272.71 526.698H270.172V511.111H272.71V516.605H275.57V518.905H272.71V526.698Z",
    fill: "#8E6545"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M292.087 522.551H285.533V526.317H282.995V522.551H277.179V520.299H292.087V522.551ZM290.871 516.879C290.609 517.368 290.204 517.797 289.656 518.166C289.108 518.535 288.417 518.821 287.594 519.024C286.772 519.227 285.819 519.334 284.722 519.334C283.626 519.334 282.649 519.238 281.839 519.024C281.028 518.821 280.337 518.535 279.789 518.166C279.241 517.797 278.824 517.368 278.55 516.867C278.276 516.367 278.144 515.83 278.144 515.246C278.144 514.662 278.276 514.114 278.55 513.626C278.824 513.125 279.229 512.696 279.789 512.327C280.337 511.957 281.028 511.671 281.839 511.457C282.649 511.242 283.614 511.135 284.722 511.135C285.831 511.135 286.772 511.242 287.594 511.457C288.417 511.671 289.108 511.957 289.656 512.327C290.204 512.696 290.621 513.125 290.895 513.626C291.169 514.126 291.3 514.662 291.3 515.246C291.3 515.83 291.157 516.378 290.883 516.879H290.871ZM296.854 532.299H279.622V526.186H282.16V530.166H296.842V532.287L296.854 532.299ZM287.737 516.581C288.405 516.212 288.738 515.759 288.738 515.234C288.738 514.71 288.405 514.257 287.737 513.876C287.07 513.495 286.057 513.304 284.711 513.304C283.364 513.304 282.351 513.495 281.684 513.876C281.016 514.257 280.683 514.71 280.683 515.234C280.683 515.759 281.016 516.2 281.684 516.581C282.351 516.95 283.364 517.141 284.711 517.141C286.057 517.141 287.07 516.95 287.737 516.581ZM296.341 527.926H293.803V526.186H288.429V524.041H293.803V511.111H296.341V527.926Z",
    fill: "#8E6545"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M281.564 501.006H279.324L276.631 497.395L273.962 501.006H271.721L275.57 495.965L271.995 491.521H274.236L276.643 494.535L279.062 491.521H281.302L277.703 495.965L281.564 501.006Z",
    fill: "#8E6545"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M292.885 501.006H282.828V496.251C282.828 495.679 282.911 495.226 283.078 494.929C283.245 494.619 283.566 494.404 284.031 494.273L290.478 493.01C290.669 492.962 290.764 492.807 290.764 492.557V488.732C290.764 488.541 290.669 488.446 290.478 488.446H285.151C284.961 488.446 284.865 488.541 284.865 488.732V491.508H282.983V488.434C282.983 487.945 283.137 487.54 283.447 487.23C283.757 486.921 284.15 486.766 284.651 486.766H290.991C291.479 486.766 291.884 486.921 292.194 487.23C292.504 487.54 292.659 487.933 292.659 488.434V492.462C292.659 493.034 292.564 493.487 292.385 493.808C292.194 494.13 291.872 494.357 291.42 494.488L285.008 495.715C284.818 495.763 284.722 495.906 284.722 496.144V499.338H292.909V500.994L292.885 501.006Z",
    fill: "#8E6545"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M305.624 494.559H295.316V486.575H304.468V488.231H297.187V489.745H304.289V491.353H297.187V492.891H305.624V494.547V494.559ZM308.853 501.9H296.758V495.941H308.853V501.9ZM306.97 500.303V497.526H298.629V500.303H306.97ZM308.853 495.357H306.97V486.253H308.853V495.357Z",
    fill: "#8E6545"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2132_129647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.1924 403.278C124.892 403.278 157.885 370.284 157.885 329.585C157.885 288.886 124.892 255.893 84.1924 255.893C43.4932 255.893 10.5 288.886 10.5 329.585C10.5 370.284 43.4932 403.278 84.1924 403.278Z",
    fill: "url(#paint58_linear_2132_129647)",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2132_129647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.6075 328.286H76.2559V314.63H74.7068V328.012H68.4267V322.662L65.4595 325.629H53.0066V298.519H66.8061V304.31H59.0483V319.766H68.4267V297.935H74.7068V308.457H76.2559V297.839H82.6075V328.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.091 314.106C100.899 313.307 99.7196 312.473 98.5517 311.627C97.3958 310.781 96.2757 309.827 95.1913 308.767C94.083 309.78 92.939 310.721 91.7593 311.591C90.5795 312.461 89.3044 313.355 87.9459 314.249L84.085 309.661C85.372 308.695 86.5755 307.766 87.6838 306.872C88.804 305.978 89.8407 305.013 90.8059 303.976C91.1277 303.655 91.3303 303.345 91.4256 303.047C91.5209 302.749 91.5686 302.356 91.5686 301.879V297.839H98.8139V301.843C98.8139 302.284 98.8616 302.666 98.9569 302.975C99.0522 303.297 99.2429 303.619 99.5408 303.941C100.482 304.954 101.483 305.907 102.544 306.824C103.604 307.73 104.725 308.672 105.928 309.637L102.103 314.117L102.091 314.106ZM107.751 315.035C108.943 315.035 109.98 315.214 110.85 315.583C111.72 315.953 112.447 316.453 113.007 317.085C113.567 317.716 113.984 318.455 114.27 319.289C114.544 320.123 114.687 321.005 114.687 321.923C114.687 322.84 114.544 323.722 114.258 324.556C113.972 325.391 113.543 326.129 112.959 326.761C112.387 327.393 111.648 327.893 110.766 328.262C109.884 328.632 108.836 328.811 107.644 328.811H93.4395C92.2479 328.811 91.2111 328.632 90.3531 328.262C89.4951 327.893 88.7801 327.393 88.232 326.761C87.6838 326.129 87.2667 325.391 87.0045 324.556C86.7424 323.722 86.6113 322.84 86.6113 321.923C86.6113 321.005 86.7543 320.123 87.0284 319.289C87.3025 318.455 87.7195 317.716 88.2915 317.085C88.8516 316.453 89.5785 315.953 90.4484 315.583C91.3184 315.214 92.3551 315.035 93.5468 315.035H107.751ZM106.202 323.21C106.727 323.21 107.156 323.091 107.465 322.864C107.775 322.638 107.93 322.328 107.93 321.935C107.93 321.541 107.775 321.232 107.477 320.981C107.179 320.743 106.75 320.624 106.202 320.624H95.0959C94.5478 320.624 94.1188 320.743 93.8208 320.981C93.5229 321.22 93.368 321.541 93.368 321.935C93.368 322.328 93.5229 322.638 93.8328 322.864C94.1426 323.091 94.5597 323.21 95.0959 323.21H106.202ZM113.507 314.249H106.75V297.827H113.507V302.582H116.891V308.374H113.507V314.237V314.249Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2132_129647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5735 357.756H34.0352V340.751H30.9131V338.499H36.5854V357.756H36.5735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9707 361.82H38.8972L39.8744 355.706H42.9727L40.9707 361.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.81 355.516C58.81 356.183 58.6074 356.731 58.1903 357.136C57.7732 357.553 57.237 357.756 56.5697 357.756H47.6322C46.9648 357.756 46.4167 357.553 46.0115 357.136C45.5944 356.719 45.3918 356.183 45.3918 355.516V340.763C45.3918 340.096 45.5944 339.559 46.0115 339.142C46.4286 338.725 46.9648 338.523 47.6322 338.523H56.5697C57.237 338.523 57.7732 338.725 58.1903 339.142C58.6074 339.559 58.81 340.096 58.81 340.763V355.516ZM55.8785 355.516C56.1406 355.516 56.2717 355.385 56.2717 355.122V341.144C56.2717 340.882 56.1406 340.751 55.8785 340.751H48.2995C48.0373 340.751 47.9063 340.882 47.9063 341.144V355.122C47.9063 355.385 48.0373 355.516 48.2995 355.516H55.8785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.279 355.516C75.279 356.183 75.0764 356.731 74.6593 357.136C74.2422 357.553 73.706 357.756 73.0386 357.756H64.1012C63.4338 357.756 62.8857 357.553 62.4805 357.136C62.0634 356.719 61.8608 356.183 61.8608 355.516V340.763C61.8608 340.096 62.0634 339.559 62.4805 339.142C62.8976 338.725 63.4338 338.523 64.1012 338.523H73.0386C73.706 338.523 74.2422 338.725 74.6593 339.142C75.0764 339.559 75.279 340.096 75.279 340.763V355.516ZM72.3475 355.516C72.6096 355.516 72.7407 355.385 72.7407 355.122V341.144C72.7407 340.882 72.6096 340.751 72.3475 340.751H64.7685C64.5063 340.751 64.3752 340.882 64.3752 341.144V355.122C64.3752 355.385 64.5063 355.516 64.7685 355.516H72.3475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7475 355.516C91.7475 356.183 91.5449 356.731 91.1278 357.136C90.7107 357.553 90.1745 357.756 89.5072 357.756H80.5697C79.9023 357.756 79.3542 357.553 78.949 357.136C78.5319 356.719 78.3293 356.183 78.3293 355.516V340.763C78.3293 340.096 78.5319 339.559 78.949 339.142C79.3661 338.725 79.9023 338.523 80.5697 338.523H89.5072C90.1745 338.523 90.7107 338.725 91.1278 339.142C91.5449 339.559 91.7475 340.096 91.7475 340.763V355.516ZM88.816 355.516C89.0781 355.516 89.2092 355.385 89.2092 355.122V341.144C89.2092 340.882 89.0781 340.751 88.816 340.751H81.237C80.9748 340.751 80.8438 340.882 80.8438 341.144V355.122C80.8438 355.385 80.9748 355.516 81.237 355.516H88.816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.452 349.45H94.5835V338.475H106.452V349.45ZM113.019 358.983H96.5259V351.702H99.0642V356.731H113.019V358.983ZM103.914 347.21V340.739H97.1217V347.21H103.914ZM112.506 353.383H109.968V337.796H112.506V343.289H115.366V345.589H112.506V353.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.883 349.236H125.341V353.001H122.802V349.236H116.987V346.983H131.895V349.236H131.883ZM130.667 343.563C130.405 344.052 130 344.481 129.44 344.85C128.892 345.22 128.201 345.506 127.378 345.708C126.556 345.911 125.603 346.018 124.506 346.018C123.41 346.018 122.433 345.923 121.623 345.708C120.812 345.506 120.121 345.22 119.573 344.85C119.025 344.481 118.608 344.052 118.334 343.551C118.06 343.051 117.928 342.515 117.928 341.931C117.928 341.347 118.06 340.799 118.334 340.31C118.608 339.81 119.013 339.381 119.573 339.011C120.121 338.642 120.812 338.356 121.623 338.141C122.433 337.927 123.398 337.819 124.506 337.819C125.615 337.819 126.556 337.927 127.378 338.141C128.201 338.356 128.892 338.642 129.44 339.011C129.988 339.381 130.405 339.81 130.679 340.31C130.953 340.811 131.084 341.347 131.084 341.931C131.084 342.515 130.941 343.063 130.667 343.563ZM136.649 358.983H119.418V352.87H121.956V356.85H136.638V358.971L136.649 358.983ZM127.533 343.265C128.201 342.896 128.534 342.443 128.534 341.919C128.534 341.394 128.201 340.942 127.533 340.56C126.866 340.179 125.853 339.988 124.506 339.988C123.16 339.988 122.147 340.179 121.48 340.56C120.812 340.942 120.479 341.394 120.479 341.919C120.479 342.443 120.812 342.884 121.48 343.265C122.147 343.635 123.16 343.825 124.506 343.825C125.853 343.825 126.866 343.635 127.533 343.265ZM136.137 354.61H133.599V352.87H128.224V350.725H133.599V337.796H136.137V354.61Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.985 329.228C150.985 292.429 121.027 262.495 84.2044 262.495C47.382 262.495 17.4116 292.429 17.4116 329.228C17.4116 366.026 47.37 395.973 84.2044 395.973C121.039 395.973 150.985 366.026 150.985 329.228ZM14.8376 329.228C14.8376 291.011 45.952 259.921 84.2044 259.921C122.457 259.921 153.559 291.011 153.559 329.228C153.559 367.444 122.445 398.547 84.2044 398.547C45.9639 398.547 14.8376 367.444 14.8376 329.228Z",
    fill: "url(#paint59_linear_2132_129647)",
    style: {
      mixBlendMode: "screen"
    }
  }), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M328.415 599.89C327.448 599.89 326.65 600.544 326.43 601.423H14.493C14.2778 600.544 13.4743 599.89 12.5083 599.89C11.3796 599.89 10.4614 600.783 10.4614 601.89C10.4614 602.998 11.3749 603.89 12.5083 603.89C13.4743 603.89 14.273 603.236 14.493 602.357H326.43C326.645 603.236 327.448 603.89 328.415 603.89C329.543 603.89 330.461 602.998 330.461 601.89C330.461 600.783 329.548 599.89 328.415 599.89Z",
    fill: "url(#paint60_linear_2132_129647)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2132_129647",
    x: 0,
    y: 245.393,
    width: 168.385,
    height: 168.385,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.756863 0 0 0 0 0.580392 0 0 0 0 0.764706 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2132_129647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2132_129647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2132_129647",
    x: 47.3466,
    y: 292.167,
    width: 75.2048,
    height: 42.3033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.756863 0 0 0 0 0.580392 0 0 0 0 0.764706 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2132_129647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2132_129647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2132_129647",
    x: 25.2531,
    y: 332.136,
    width: 117.056,
    height: 35.344,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.83
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.756863 0 0 0 0 0.580392 0 0 0 0 0.764706 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2132_129647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2132_129647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2132_129647",
    x1: 87.3726,
    y1: -0.0188971,
    x2: 87.3726,
    y2: 20.2861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9A9CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9688B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8579B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#635F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5C4F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4B93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2132_129647",
    x1: 253.543,
    y1: -0.0261905,
    x2: 253.543,
    y2: -0.0261905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9A9CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9688B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8579B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#635F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5C4F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4B93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2132_129647",
    x1: 170.454,
    y1: 73.7435,
    x2: 170.454,
    y2: 125.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9A9CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9688B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8579B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#635F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5C4F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4B93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2132_129647",
    x1: 249.452,
    y1: 115.07,
    x2: 189.127,
    y2: 219.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#DDDEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#37383A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C8C9CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#A2A3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#7C7D7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#5D5E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#48494B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3B3C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#37383A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#C8C9CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#37383A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DDDEE4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2132_129647",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(379.236 462.134) scale(281.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DCB951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7DE8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2132_129647",
    x1: 183.756,
    y1: 329.228,
    x2: 330.461,
    y2: 329.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2132_129647",
    x1: 184.006,
    y1: 329.228,
    x2: 330.211,
    y2: 329.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2132_129647",
    x1: 184.256,
    y1: 12.722,
    x2: 329.961,
    y2: 12.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2132_129647",
    x1: 184.507,
    y1: 329.228,
    x2: 329.711,
    y2: 329.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2132_129647",
    x1: 184.757,
    y1: 329.228,
    x2: 329.46,
    y2: 329.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2132_129647",
    x1: 185.007,
    y1: 329.228,
    x2: 329.21,
    y2: 329.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2132_129647",
    x1: 185.257,
    y1: 329.228,
    x2: 328.96,
    y2: 329.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2132_129647",
    x1: 185.508,
    y1: 12.7221,
    x2: 328.722,
    y2: 12.7221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2132_129647",
    x1: 185.758,
    y1: 329.228,
    x2: 328.471,
    y2: 329.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2132_129647",
    x1: 186.008,
    y1: 329.228,
    x2: 328.221,
    y2: 329.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2132_129647",
    x1: 186.258,
    y1: 12.7221,
    x2: 327.971,
    y2: 12.7221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2132_129647",
    x1: 186.509,
    y1: 329.228,
    x2: 327.721,
    y2: 329.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2132_129647",
    x1: 186.759,
    y1: 12.7221,
    x2: 327.47,
    y2: 12.7221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2132_129647",
    x1: 186.997,
    y1: 329.228,
    x2: 327.22,
    y2: 329.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2132_129647",
    x1: 187.247,
    y1: 329.228,
    x2: 326.97,
    y2: 329.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2132_129647",
    x1: 187.498,
    y1: 329.228,
    x2: 326.72,
    y2: 329.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2132_129647",
    x1: 257.109,
    y1: 259.914,
    x2: 257.109,
    y2: 398.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2132_129647",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.942 635.449) scale(281.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2132_129647",
    x1: 10.4733,
    y1: 502.543,
    x2: 157.167,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2132_129647",
    x1: 10.7236,
    y1: 502.543,
    x2: 156.917,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2132_129647",
    x1: 10.9739,
    y1: 186.038,
    x2: 156.667,
    y2: 186.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2132_129647",
    x1: 11.2241,
    y1: 502.543,
    x2: 156.428,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2132_129647",
    x1: 11.4624,
    y1: 502.543,
    x2: 156.178,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2132_129647",
    x1: 11.7126,
    y1: 502.543,
    x2: 155.928,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2132_129647",
    x1: 11.9629,
    y1: 502.543,
    x2: 155.677,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2132_129647",
    x1: 12.2131,
    y1: 186.038,
    x2: 155.427,
    y2: 186.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2132_129647",
    x1: 12.4634,
    y1: 502.543,
    x2: 155.177,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2132_129647",
    x1: 12.7136,
    y1: 502.543,
    x2: 154.927,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2132_129647",
    x1: 12.9639,
    y1: 186.038,
    x2: 154.676,
    y2: 186.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2132_129647",
    x1: 13.2141,
    y1: 502.543,
    x2: 154.426,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2132_129647",
    x1: 13.4644,
    y1: 186.038,
    x2: 154.176,
    y2: 186.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2132_129647",
    x1: 13.7146,
    y1: 502.543,
    x2: 153.926,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2132_129647",
    x1: 13.9651,
    y1: 502.543,
    x2: 153.676,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2132_129647",
    x1: 14.2153,
    y1: 502.543,
    x2: 153.425,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2132_129647",
    x1: 83.8268,
    y1: 433.23,
    x2: 83.8268,
    y2: 571.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E3E2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#757575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#A09F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#868586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E2E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2132_129647",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(378.506 635.449) scale(281.9 281.9)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E29957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FAF8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E29957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C189"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2132_129647",
    x1: 183.038,
    y1: 502.543,
    x2: 329.743,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2132_129647",
    x1: 183.288,
    y1: 502.543,
    x2: 329.493,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2132_129647",
    x1: 183.538,
    y1: 186.038,
    x2: 329.243,
    y2: 186.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2132_129647",
    x1: 183.788,
    y1: 502.543,
    x2: 328.993,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2132_129647",
    x1: 184.039,
    y1: 502.543,
    x2: 328.742,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2132_129647",
    x1: 184.289,
    y1: 502.543,
    x2: 328.492,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2132_129647",
    x1: 184.539,
    y1: 502.543,
    x2: 328.242,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2132_129647",
    x1: 184.789,
    y1: 186.038,
    x2: 327.991,
    y2: 186.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2132_129647",
    x1: 185.04,
    y1: 502.543,
    x2: 327.741,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2132_129647",
    x1: 185.278,
    y1: 502.543,
    x2: 327.491,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2132_129647",
    x1: 185.528,
    y1: 186.038,
    x2: 327.241,
    y2: 186.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2132_129647",
    x1: 185.778,
    y1: 502.543,
    x2: 326.99,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2132_129647",
    x1: 186.029,
    y1: 186.038,
    x2: 326.752,
    y2: 186.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2132_129647",
    x1: 186.279,
    y1: 502.543,
    x2: 326.502,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2132_129647",
    x1: 186.529,
    y1: 502.543,
    x2: 326.251,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2132_129647",
    x1: 186.779,
    y1: 502.543,
    x2: 326.001,
    y2: 502.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2132_129647",
    x1: 256.391,
    y1: 433.23,
    x2: 256.391,
    y2: 571.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D5803B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBF2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7C189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF6D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#DBA05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CD7C3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF2C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2132_129647",
    x1: 121.051,
    y1: 265.748,
    x2: 47.3343,
    y2: 393.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9A9CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9688B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8579B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#635F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5C4F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4B93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2132_129647",
    x1: 84.1989,
    y1: 259.914,
    x2: 84.1989,
    y2: 398.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#D3AA41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F3F4C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F7DE8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BB942E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D8C064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#CCA33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2132_129647",
    x1: 210.973,
    y1: 533.329,
    x2: 132.732,
    y2: 672.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9A9CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9688B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#8579B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#635F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5C4F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A4B93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardMobile);
export default __webpack_public_path__ + "static/media/award-mobile.140132bdb296b0b7dacbb93a92ae60e2.svg";
export { ForwardRef as ReactComponent };